import React, {useState, useEffect, useRef, useMemo} from "react";
import {connect} from "react-redux";
import {
  Spinner,
  Row,
  Col,
  Table,
  Card,
  CardBody,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Alert,
  Progress
} from "reactstrap";
import PageHeader from "./components/PageHeader";
import {
  getMantisAgents,
  getMantisAgentByIdWithDecryptedData,
  updateMantisAgent,
  buildAgent,
  createMantisAgent,
  pollAgentDeploymentStatus,
  pollAgentDeploymentStatusWithUpdates
} from "../ApiCalls/mantisAgents";
import {
  createDeployment,
  getDeployments,
  deleteDeployment,
  deleteDeploymentsBatch,
  createTestSession,
  sendTestMessage,
  deleteTestSession
} from "../ApiCalls/agentManager";
import {
  getMCPTools,
  createMCPTool,
  updateMCPTool,
  deleteMCPTool,
} from "../ApiCalls/mcpTools";
import { backUrl } from "../utils/backURL";
import { sendBulkTemplates } from "../ApiCalls/bulkTemplate";
import Sessions from "./Sessions";
import Conversations from "./Conversations";
import DatabaseConnectionsForm from "./components/DatabaseConnectionsForm";
import WhatsAppAccountsForm from "./components/WhatsAppAccountsForm";
import AgentTestModal from "./components/AgentTestModal";
import * as XLSX from "xlsx";

const select = (state) => {
  return {
    userId: state.auth.userId,
    token: state.auth.token,
  };
};

const Agentes = (props) => {
  const [activeTab, setActiveTab] = useState("agentes");
  const [sessionsTabLoaded, setSessionsTabLoaded] = useState(false);
  const [conversationsTabLoaded, setConversationsTabLoaded] = useState(false);
  const [agents, setAgents] = useState([]);
  const [editLoadingAgentId, setEditLoadingAgentId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Edit modal states
  const [editModal, setEditModal] = useState(false);
  const [editingAgent, setEditingAgent] = useState(null);
  const [editForm, setEditForm] = useState({
    name: "",
    description: "",
    type: "GENERAL",
    isActive: true,
    activeTo: "",
    fallbackMessage: "",
    systemInstructions: "",
    agentId: "",
    model: "gemini-2.5-pro",
    cacheTime: 10,
    proactiveEnabled: false,
    proactiveMaxDelayMinutes: 10080,
    tools: [],
    databaseConnections: [],
    whatsappAccounts: [],
  });
  const [editLoading, setEditLoading] = useState(false);
  const [editError, setEditError] = useState(null);
  const [redeployLoading, setRedeployLoading] = useState(false);

  // View modal states
  const [viewModal, setViewModal] = useState(false);
  const [viewingAgent, setViewingAgent] = useState(null);
  const [isCompiling, setIsCompiling] = useState(false);
  const [buildSuccessModal, setBuildSuccessModal] = useState(false);
  const [buildId, setBuildId] = useState("");

  // Bulk template modal states
  const [bulkTemplateModal, setBulkTemplateModal] = useState(false);
  const [selectedWhatsAppAccount, setSelectedWhatsAppAccount] = useState(null);
  const [bulkTemplateAgent, setBulkTemplateAgent] = useState(null);
  const [bulkTemplateForm, setBulkTemplateForm] = useState({
    templateName: "",
    excelFile: null,
    language: "es_MX",
  });
  const [bulkTemplateLoading, setBulkTemplateLoading] = useState(false);
  const [bulkTemplateError, setBulkTemplateError] = useState(null);
  const [bulkTemplateSuccess, setBulkTemplateSuccess] = useState(null);
  const [bulkTemplateResults, setBulkTemplateResults] = useState(null);
  const [showDetailedResults, setShowDetailedResults] = useState(false);
  const [bulkTemplateProgress, setBulkTemplateProgress] = useState({
    currentBatch: 0,
    totalBatches: 0,
    currentSent: 0,
    currentFailed: 0,
    totalRecipients: 0
  });

  // Create modal states
  const [createModal, setCreateModal] = useState(false);
  const [createForm, setCreateForm] = useState({
    name: "",
    description: "",
    type: "GENERAL",
    activeTo: "",
    fallbackMessage: "",
    systemInstructions: "",
    agentId: "",
    model: "gemini-2.5-pro",
    cacheTime: 10,
    proactiveEnabled: false,
    proactiveMaxDelayMinutes: 10080,
    tools: [],
    databaseConnections: [],
    whatsappAccounts: [],
  });
  const [createLoading, setCreateLoading] = useState(false);
  const [createError, setCreateError] = useState(null);
  const [scheduleDeactivationCreate, setScheduleDeactivationCreate] = useState(false);
  const [scheduleDeactivationEdit, setScheduleDeactivationEdit] = useState(false);

  // Agent Manager states
  const [deployments, setDeployments] = useState([]);
  const [deploymentsLoading, setDeploymentsLoading] = useState(false);
  const [deploymentsError, setDeploymentsError] = useState(null);
  const [selectedDeployments, setSelectedDeployments] = useState(new Set());
  const [deleteLoading, setDeleteLoading] = useState(false);
  const deploymentsLoadedRef = useRef(false);

  // Test Agent modal states
  const [testModal, setTestModal] = useState(false);
  const [testModalReturnTo, setTestModalReturnTo] = useState(null);
  const [testSessionId, setTestSessionId] = useState(null);
  const [testMessages, setTestMessages] = useState([]);
  const [testLoading, setTestLoading] = useState(false);
  const [testError, setTestError] = useState(null);
  const [testInitializing, setTestInitializing] = useState(false);

  // MCP Tools states
  const [mcpTools, setMcpTools] = useState([]);
  const [mcpToolsLoading, setMcpToolsLoading] = useState(false);
  const [mcpToolsError, setMcpToolsError] = useState(null);
  const [mcpToolModal, setMcpToolModal] = useState(false);
  const [editingMcpTool, setEditingMcpTool] = useState(null);
  const [mcpToolForm, setMcpToolForm] = useState({
    name: "",
    identifier: "",
    description: "",
    type: "builtin",
    httpConfig: {
      url: "",
      method: "GET",
      headers: null,
      requestBodySchema: null,
      defaultBody: null,
      defaultQueryParams: null,
    },
  });
  const [mcpToolFormLoading, setMcpToolFormLoading] = useState(false);
  const [mcpToolFormError, setMcpToolFormError] = useState(null);
  const [mcpToolsDropdownOpen, setMcpToolsDropdownOpen] = useState(false);
  const [mcpToolsDropdownOpenEdit, setMcpToolsDropdownOpenEdit] =
    useState(false);
  const [mcpToolsSearch, setMcpToolsSearch] = useState("");
  const [mcpToolsSearchEdit, setMcpToolsSearchEdit] = useState("");
  const [mcpToolsListSearch, setMcpToolsListSearch] = useState("");

  useEffect(() => {
    fetchAgents();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // Only fetch deployments on first load of the agent-manager tab
    if (activeTab === "agent-manager" && !deploymentsLoadedRef.current) {
      fetchDeployments();
      deploymentsLoadedRef.current = true;
    }
    // Fetch MCP Tools when MCP Tools tab is active
    if (activeTab === "mcp-tools") {
      fetchMCPTools();
    }
    // Sessions/Conversations mount their own data-fetching effects, so only
    // render them once their tab has actually been opened — reactstrap's
    // TabPane renders all children on mount regardless of which tab is active.
    if (activeTab === "sesiones" && !sessionsTabLoaded) {
      setSessionsTabLoaded(true);
    }
    if (activeTab === "conversaciones" && !conversationsTabLoaded) {
      setConversationsTabLoaded(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- fetchMCPTools is redefined every render; adding it would re-trigger this effect in a loop, and fetchDeployments guards itself via deploymentsLoadedRef
  }, [activeTab]);

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        mcpToolsDropdownOpen &&
        !event.target.closest("[data-mcp-tools-dropdown]")
      ) {
        setMcpToolsDropdownOpen(false);
      }
      if (
        mcpToolsDropdownOpenEdit &&
        !event.target.closest("[data-mcp-tools-dropdown-edit]")
      ) {
        setMcpToolsDropdownOpenEdit(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [mcpToolsDropdownOpen, mcpToolsDropdownOpenEdit]);

  // Navigation protection during compilation
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (isCompiling) {
        e.preventDefault();
        e.returnValue =
          "La compilación está en progreso. ¿Estás seguro de que quieres salir?";
        return "La compilación está en progreso. ¿Estás seguro de que quieres salir?";
      }
    };

    const handlePopState = (e) => {
      if (isCompiling) {
        e.preventDefault();
        alert(
          "La compilación está en progreso. No puedes navegar hasta que termine."
        );
        window.history.pushState(null, null, window.location.pathname);
      }
    };

    if (isCompiling) {
      window.addEventListener("beforeunload", handleBeforeUnload);
      window.addEventListener("popstate", handlePopState);
      window.history.pushState(null, null, window.location.pathname);
    }

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("popstate", handlePopState);
    };
  }, [isCompiling]);

  // Navigation protection during compilation
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (isCompiling) {
        e.preventDefault();
        e.returnValue =
          "La compilación está en progreso. ¿Estás seguro de que quieres salir?";
        return "La compilación está en progreso. ¿Estás seguro de que quieres salir?";
      }
    };

    const handlePopState = (e) => {
      if (isCompiling) {
        e.preventDefault();
        alert(
          "La compilación está en progreso. No puedes navegar hasta que termine."
        );
        window.history.pushState(null, null, window.location.pathname);
      }
    };

    if (isCompiling) {
      window.addEventListener("beforeunload", handleBeforeUnload);
      window.addEventListener("popstate", handlePopState);
      window.history.pushState(null, null, window.location.pathname);
    }

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("popstate", handlePopState);
    };
  }, [isCompiling]);

  const fetchAgents = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await getMantisAgents(props.token);
      setAgents(data.data || []);
    } catch (err) {
      setError("Error al cargar los agentes");
      console.error("Error fetching agents:", err);
    } finally {
      setLoading(false);
    }
  };

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const fetchMCPTools = async () => {
    try {
      setMcpToolsLoading(true);
      setMcpToolsError(null);
      const data = await getMCPTools(props.token);
      setMcpTools(data.data || []);
    } catch (err) {
      setMcpToolsError("Error al cargar las herramientas MCP");
      console.error("Error fetching MCP tools:", err);
    } finally {
      setMcpToolsLoading(false);
    }
  };

  const openMcpToolModal = (tool = null) => {
    setEditingMcpTool(tool);
    const cfg = tool?.httpConfig || {};
    setMcpToolForm({
      name: tool ? tool.name : "",
      identifier: tool ? tool.identifier : "",
      description: tool ? tool.description || "" : "",
      type: tool ? (tool.type || "builtin") : "builtin",
      httpConfig: {
        url: cfg.url || "",
        method: cfg.method || "GET",
        headers: cfg.headers ?? null,
        requestBodySchema: cfg.requestBodySchema ?? null,
        defaultBody: cfg.defaultBody ?? null,
        defaultQueryParams: cfg.defaultQueryParams ?? null,
      },
    });
    setMcpToolFormError(null);
    setMcpToolModal(true);
  };

  const closeMcpToolModal = () => {
    setMcpToolModal(false);
    setEditingMcpTool(null);
    setMcpToolForm({
      name: "",
      identifier: "",
      description: "",
      type: "builtin",
      httpConfig: {
        url: "",
        method: "GET",
        headers: null,
        requestBodySchema: null,
        defaultBody: null,
        defaultQueryParams: null,
      },
    });
    setMcpToolFormError(null);
  };

  const handleMcpToolFormChange = (field, value) => {
    setMcpToolForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleMcpToolHttpConfigChange = (field, value) => {
    setMcpToolForm((prev) => ({
      ...prev,
      httpConfig: {
        ...prev.httpConfig,
        [field]: value,
      },
    }));
  };

  const handleMcpToolSubmit = async () => {
    try {
      setMcpToolFormLoading(true);
      setMcpToolFormError(null);

      if (!mcpToolForm.name.trim() || !mcpToolForm.identifier.trim()) {
        setMcpToolFormError("El nombre y el identificador son requeridos");
        return;
      }

      if (mcpToolForm.type === "http") {
        if (!mcpToolForm.httpConfig?.url?.trim()) {
          setMcpToolFormError("Las herramientas HTTP requieren una URL");
          return;
        }
      }

      const payload = {
        name: mcpToolForm.name.trim(),
        identifier: mcpToolForm.identifier.trim(),
        description: (mcpToolForm.description || "").trim(),
        type: mcpToolForm.type || "builtin",
      };
      if (mcpToolForm.type === "http" && mcpToolForm.httpConfig) {
        payload.httpConfig = {
          url: mcpToolForm.httpConfig.url.trim(),
          method: (mcpToolForm.httpConfig.method || "GET").toUpperCase(),
        };
        if (mcpToolForm.httpConfig.headers != null) payload.httpConfig.headers = mcpToolForm.httpConfig.headers;
        if (mcpToolForm.httpConfig.requestBodySchema != null) payload.httpConfig.requestBodySchema = mcpToolForm.httpConfig.requestBodySchema;
        if (mcpToolForm.httpConfig.defaultBody != null) payload.httpConfig.defaultBody = mcpToolForm.httpConfig.defaultBody;
        if (mcpToolForm.httpConfig.defaultQueryParams != null) payload.httpConfig.defaultQueryParams = mcpToolForm.httpConfig.defaultQueryParams;
      }

      if (editingMcpTool) {
        await updateMCPTool(props.token, editingMcpTool._id, payload);
      } else {
        await createMCPTool(props.token, payload);
      }

      closeMcpToolModal();
      fetchMCPTools();
    } catch (err) {
      setMcpToolFormError(err.message || "Error al guardar la herramienta MCP");
      console.error("Error saving MCP tool:", err);
    } finally {
      setMcpToolFormLoading(false);
    }
  };

  const handleDeleteMcpTool = async (toolId) => {
    if (
      !window.confirm(
        "¿Estás seguro de que deseas eliminar esta herramienta MCP?"
      )
    ) {
      return;
    }

    try {
      await deleteMCPTool(props.token, toolId);
      fetchMCPTools();
    } catch (err) {
      alert("Error al eliminar la herramienta MCP: " + err.message);
      console.error("Error deleting MCP tool:", err);
    }
  };

  const getDeploymentStatusBadge = (status) => {
    if (!status) {
      return null; // No deployment status
    }

    const statusConfig = {
      pending: {
        label: "Pendiente",
        className: "bg-warning text-dark",
        icon: "fa-clock",
      },
      in_progress: {
        label: "En progreso",
        className: "bg-info text-white",
        icon: "fa-spinner fa-spin",
      },
      completed: {
        label: "Completado",
        className: "bg-success text-white",
        icon: "fa-check-circle",
      },
      failed: {
        label: "Fallido",
        className: "bg-danger text-white",
        icon: "fa-times-circle",
      },
    };

    const config = statusConfig[status];
    if (!config) return null;

    return (
      <span
        className={`badge ${config.className} me-2`}
        title={`Estado de despliegue: ${config.label}`}
      >
        <i className={`fas ${config.icon} me-1`}></i>
        {config.label}
      </span>
    );
  };

  const getAgentTypeLabel = (type) => {
    const typeLabels = {
      GENERAL: "General",
      INITIAL_PURCHASE_REQUESTS: "Solicitudes de Compra",
      SUPPLIER_QUOTATIONS: "Cotizaciones de Proveedores",
      WHATSAPP_SUPPLIER_QUOTATIONS: "Cotizaciones WhatsApp",
    };
    return typeLabels[type] || type;
  };

  const openEditModal = async (agent) => {
    setEditError(null);
    setEditLoadingAgentId(agent._id);
    try {
      // The list only carries non-sensitive fields; fetch this single
      // agent's decrypted databaseConnections/whatsappAccounts on demand
      // instead of decrypting every agent up front just to render the list.
      const decryptedResponse = await getMantisAgentByIdWithDecryptedData(
        props.token,
        agent._id
      );
      const fullAgent = decryptedResponse?.data || agent;

      setEditingAgent(fullAgent);
      setEditForm({
        name: fullAgent.name || "",
        description: fullAgent.description || "",
        type: fullAgent.type || "GENERAL",
        isActive: fullAgent.isActive !== undefined ? fullAgent.isActive : true,
        activeTo: toDateInputValue(fullAgent.activeTo),
        fallbackMessage: fullAgent.fallbackMessage || "",
        systemInstructions: fullAgent.systemInstructions || "",
        agentId: fullAgent.agentId || "",
        model: fullAgent.model || "gemini-2.5-pro",
        cacheTime: fullAgent.cacheTime !== undefined ? fullAgent.cacheTime : 10,
        proactiveEnabled: !!fullAgent.proactiveEnabled,
        proactiveMaxDelayMinutes:
          fullAgent.proactiveMaxDelayMinutes !== undefined &&
          fullAgent.proactiveMaxDelayMinutes !== null
            ? fullAgent.proactiveMaxDelayMinutes
            : 10080,
        tools: fullAgent.tools || [],
        databaseConnections: fullAgent.databaseConnections || [],
        whatsappAccounts: fullAgent.whatsappAccounts || [],
      });
      setScheduleDeactivationEdit(!!fullAgent.activeTo);
      setRedeployLoading(false);
      setEditModal(true);
      // Fetch MCP Tools if not already loaded
      if (mcpTools.length === 0) {
        fetchMCPTools();
      }
    } catch (err) {
      console.error("Error fetching decrypted agent data:", err);
      setError("Error al cargar los datos del agente para edición");
    } finally {
      setEditLoadingAgentId(null);
    }
  };

  const closeEditModal = () => {
    setEditModal(false);
    setEditingAgent(null);
    setEditForm({
      name: "",
      description: "",
      type: "GENERAL",
      isActive: true,
      activeTo: "",
      fallbackMessage: "",
      systemInstructions: "",
      agentId: "",
      model: "gemini-2.5-pro",
      cacheTime: 10,
      proactiveEnabled: false,
      proactiveMaxDelayMinutes: 10080,
      tools: [],
      databaseConnections: [],
      whatsappAccounts: [],
    });
    setScheduleDeactivationEdit(false);
    setEditError(null);
    setRedeployLoading(false);
  };

  const openCreateModal = () => {
    setCreateModal(true);
    setCreateError(null);
    setScheduleDeactivationCreate(false);
    // Fetch MCP Tools if not already loaded
    if (mcpTools.length === 0) {
      fetchMCPTools();
    }
  };

  const closeCreateModal = () => {
    setCreateModal(false);
    setCreateForm({
      name: "",
      description: "",
      type: "GENERAL",
      activeTo: "",
      fallbackMessage: "",
      systemInstructions: "",
      agentId: "",
      model: "gemini-2.5-pro",
      cacheTime: 10,
      proactiveEnabled: false,
      proactiveMaxDelayMinutes: 10080,
      tools: [],
      databaseConnections: [],
      whatsappAccounts: [],
    });
    setScheduleDeactivationCreate(false);
    setCreateError(null);
  };

  const handleCreateFormChange = (field, value) => {
    setCreateForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleCreateSubmit = async () => {
    try {
      setCreateLoading(true);
      setCreateError(null);

      // First, create the agent in the database
      const result = await createMantisAgent(props.token, {
        ...createForm,
        activeTo: scheduleDeactivationCreate ? (createForm.activeTo || null) : null,
      });

      if (result.success) {
        // If agentId is provided, skip deployment and just use the provided ID
        if (createForm.agentId && createForm.agentId.trim()) {
          // Agent ID is already set, no need to deploy
          setAgents((prev) => [result.data, ...prev]);
          closeCreateModal();
        } else {
          // Agent ID is not provided, create deployment and update agent with the obtained ID
          let deploymentWarning = null;

          try {
            // Set deployment status to pending
            await updateMantisAgent(props.token, result.data._id, {
              deploymentStatus: "pending",
            });

            // Update local state immediately with pending status so user sees it right away
            const agentWithPendingStatus = {
              ...result.data,
              deploymentStatus: "pending",
            };
            setAgents((prev) => [agentWithPendingStatus, ...prev]);

            // Build webhook URL (backend URL + webhook endpoint)
            const webhookUrl = `${backUrl}/mantis-agents/webhook/deployment`;

            const deploymentData = {
              name: createForm.name,
              system_instructions: createForm.systemInstructions,
              model: createForm.model || "gemini-2.5-pro",
              description: createForm.description || "",
              tools: createForm.tools || [],
              agent_id: result.data._id,
              webhook_url: webhookUrl,
            };

            const deploymentResult = await createDeployment(deploymentData);

            if (deploymentResult.success) {
              // Update agent status to in_progress
              await updateMantisAgent(props.token, result.data._id, {
                deploymentStatus: "in_progress",
              });

              // Update local state immediately with in_progress status
              setAgents((prev) =>
                prev.map((agent) =>
                  agent._id === result.data._id
                    ? { ...agent, deploymentStatus: "in_progress" }
                    : agent
                )
              );

              // Start polling for deployment status with real-time UI updates
              console.log(
                `Starting to poll deployment status for agent ${result.data._id}`
              );

              pollAgentDeploymentStatusWithUpdates(
                props.token,
                result.data._id,
                (updatedAgent) => {
                  // Update local state on each poll so user sees status changes in real-time
                  console.log(
                    `[UI Update] Updating agent ${result.data._id} with status: ${updatedAgent.deploymentStatus}`
                  );
                  setAgents((prev) =>
                    prev.map((agent) =>
                      agent._id === result.data._id ? updatedAgent : agent
                    )
                  );
                }
              )
                .then((pollResult) => {
                  if (pollResult.success) {
                    console.log(
                      "Deployment completed successfully:",
                      pollResult.data
                    );
                    // Final refresh to ensure we have the latest data
                    fetchAgents();
                  } else {
                    console.error("Deployment failed:", pollResult.error);
                    // Final refresh to ensure we have the latest data
                    fetchAgents();
                  }
                })
                .catch((err) => {
                  console.error("Error polling deployment status:", err);
                  // Refresh on error
                  fetchAgents();
                });
            } else {
              // Deployment request failed - log but don't set status to failed yet
              // The webhook will handle the actual failure status
              console.error(
                "Deployment request failed:",
                deploymentResult.error
              );
              // Keep status as "pending" - the webhook will update it if deployment actually fails
              deploymentWarning = `La solicitud de implementación falló: ${deploymentResult.error}. El agente se creó pero la implementación no se inició.`;
            }
          } catch (deploymentErr) {
            // Log deployment error but don't fail the agent creation
            console.error("Error creating deployment:", deploymentErr);
            // Keep status as "pending" - don't mark as failed unless webhook confirms it
            deploymentWarning = `Error al iniciar la implementación: ${deploymentErr.message}. El agente se creó pero la implementación no se inició.`;
          }

          // Show warning if deployment failed, but still close modal since agent was created
          if (deploymentWarning) {
            setCreateError(`Agente creado exitosamente. ${deploymentWarning}`);
            // Close modal after showing the message
            setTimeout(() => {
              closeCreateModal();
            }, 3000);
          } else {
            closeCreateModal();
          }
        }
      } else {
        setCreateError("Error al crear el agente");
      }
    } catch (err) {
      setCreateError("Error al crear el agente: " + err.message);
      console.error("Error creating agent:", err);
    } finally {
      setCreateLoading(false);
    }
  };

  const openViewModal = (agent) => {
    setViewingAgent(agent);
    setViewModal(true);
  };

  const closeViewModal = () => {
    setViewModal(false);
    setViewingAgent(null);
  };

  const handleEditFormChange = (field, value) => {
    setEditForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleEditSubmit = async () => {
    try {
      setEditLoading(true);
      setEditError(null);

      const agentId = editingAgent._id;
      const updateData = {
        name: editForm.name,
        description: editForm.description,
        type: editForm.type,
        isActive: editForm.isActive,
        activeTo: scheduleDeactivationEdit ? (editForm.activeTo || null) : null,
        fallbackMessage: editForm.fallbackMessage,
        systemInstructions: editForm.systemInstructions,
        agentId: editForm.agentId,
        model: editForm.model,
        cacheTime: editForm.cacheTime,
        proactiveEnabled: !!editForm.proactiveEnabled,
        proactiveMaxDelayMinutes: Number(editForm.proactiveMaxDelayMinutes) || 10080,
        tools: editForm.tools || [],
        databaseConnections: editForm.databaseConnections,
        whatsappAccounts: editForm.whatsappAccounts,
      };

      const result = await updateMantisAgent(props.token, agentId, updateData);

      if (result.success) {
        // Update the agents list with the updated agent
        setAgents((prevAgents) =>
          prevAgents.map((agent) =>
            agent._id === agentId ? { ...agent, ...updateData } : agent
          )
        );
        closeEditModal();
      } else {
        setEditError("Error al actualizar el agente");
      }
    } catch (err) {
      setEditError("Error al actualizar el agente: " + err.message);
      console.error("Error updating agent:", err);
    } finally {
      setEditLoading(false);
    }
  };

  // Check if systemInstructions, model, or tools have changed
  const hasDeploymentChanges = () => {
    if (!editingAgent) return false;

    // Check systemInstructions and model
    const systemInstructionsChanged =
      editForm.systemInstructions !== (editingAgent.systemInstructions || "");
    const modelChanged =
      editForm.model !== (editingAgent.model || "gemini-2.5-pro");

    // Check if tools have changed
    const currentTools = (editForm.tools || []).sort();
    const originalTools = (editingAgent.tools || []).sort();
    const toolsChanged =
      JSON.stringify(currentTools) !== JSON.stringify(originalTools);

    return systemInstructionsChanged || modelChanged || toolsChanged;
  };

  const handleSaveAndRedeploy = async () => {
    try {
      setRedeployLoading(true);
      setEditError(null);

      const agentId = editingAgent._id;

      // First, update the MongoDB document
      const updateData = {
        name: editForm.name,
        description: editForm.description,
        type: editForm.type,
        isActive: editForm.isActive,
        activeTo: scheduleDeactivationEdit ? (editForm.activeTo || null) : null,
        fallbackMessage: editForm.fallbackMessage || "",
        systemInstructions: editForm.systemInstructions,
        model: editForm.model,
        cacheTime: editForm.cacheTime,
        proactiveEnabled: !!editForm.proactiveEnabled,
        proactiveMaxDelayMinutes: Number(editForm.proactiveMaxDelayMinutes) || 10080,
        tools: editForm.tools || [],
        databaseConnections: editForm.databaseConnections,
        whatsappAccounts: editForm.whatsappAccounts,
      };

      const result = await updateMantisAgent(props.token, agentId, updateData);

      if (!result.success) {
        setEditError("Error al actualizar el agente");
        return;
      }

      // Then, create a new deployment using webhook pattern
      try {
        // Set deployment status to pending
        await updateMantisAgent(props.token, agentId, {
          deploymentStatus: "pending",
        });

        // Build webhook URL
        const webhookUrl = `${backUrl}/mantis-agents/webhook/deployment`;

        const deploymentData = {
          name: editForm.name,
          system_instructions: editForm.systemInstructions,
          model: editForm.model || "gemini-2.5-pro",
          description: editForm.description || "",
          tools:
            editForm.tools && editForm.tools.length > 0 ? editForm.tools : [],
          agent_id: agentId,
          webhook_url: webhookUrl,
        };

        const deploymentResult = await createDeployment(deploymentData);

        if (deploymentResult.success) {
          // Update agent status to in_progress
          await updateMantisAgent(props.token, agentId, {
            deploymentStatus: "in_progress",
          });

          // Start polling for deployment status
          console.log(
            `Starting to poll deployment status for agent ${agentId}`
          );
          pollAgentDeploymentStatus(props.token, agentId)
            .then((pollResult) => {
              if (pollResult.success) {
                console.log(
                  "Deployment completed successfully:",
                  pollResult.data
                );
                // Refresh agents list - webhook already updated the agent
                fetchAgents();
              } else {
                console.error("Deployment failed:", pollResult.error);
                fetchAgents();
              }
            })
            .catch((err) => {
              console.error("Error polling deployment status:", err);
            });

          // Update the agents list immediately (status will be updated via webhook)
          setAgents((prevAgents) =>
            prevAgents.map((agent) =>
              agent._id === agentId
                ? { ...agent, ...updateData, deploymentStatus: "in_progress" }
                : agent
            )
          );

          // Update editingAgent to reflect changes
          setEditingAgent((prev) => ({ ...prev, ...updateData }));

          closeEditModal();
        } else {
          setEditError(
            `Agente actualizado, pero la implementación falló: ${deploymentResult.error}`
          );
        }
      } catch (deploymentErr) {
        console.error("Error creating deployment:", deploymentErr);
        setEditError(
          `Agente actualizado, pero la implementación falló: ${deploymentErr.message}`
        );
      }
    } catch (err) {
      setEditError(
        "Error al actualizar y redesplegar el agente: " + err.message
      );
      console.error("Error updating and redeploying agent:", err);
    } finally {
      setRedeployLoading(false);
    }
  };

  const toDateInputValue = (dateValue) => {
    if (!dateValue) return "";
    const date = new Date(dateValue);
    if (Number.isNaN(date.getTime())) return "";
    return date.toISOString().slice(0, 10);
  };

  // Mirrors the backend's dynamic active check: isActive AND (if set) not
  // yet past its activeTo expiration date.
  const isCurrentlyActiveAgent = (agent) => {
    if (!agent || !agent.isActive) return false;
    if (!agent.activeTo) return true;
    return new Date() <= new Date(agent.activeTo);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString("es-ES", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const handleCompile = async (agent) => {
    try {
      setIsCompiling(true);

      // Create a timeout promise (10 minutes)
      const timeoutPromise = new Promise((_, reject) => {
        setTimeout(
          () =>
            reject(
              new Error("Timeout: La compilación tardó más de 10 minutos")
            ),
          10 * 60 * 1000
        );
      });

      // Race between the build request and timeout
      const result = await Promise.race([
        buildAgent(agent.managerBaseUrl, agent.agentGCSBucket),
        timeoutPromise,
      ]);

      if (result.success) {
        const extractedBuildId = result.data.resource_name.split("/")[5];
        setBuildId(extractedBuildId);
        setBuildSuccessModal(true);
        console.log("Build ID:", extractedBuildId);
      } else {
        alert(`Error calling build endpoint: ${result.error}`);
      }
    } catch (error) {
      console.error("Error calling build endpoint:", error);
      alert(`Error calling build endpoint: ${error.message}`);
    } finally {
      setIsCompiling(false);
    }
  };

  const copyBuildId = async () => {
    try {
      await navigator.clipboard.writeText(buildId);
      alert("Build ID copiado al portapapeles");
    } catch (err) {
      console.error("Error copying to clipboard:", err);
      alert("Error al copiar el Build ID");
    }
  };

  const saveBuildIdToAgent = async () => {
    try {
      const updateData = {
        agentId: buildId,
      };

      const result = await updateMantisAgent(
        props.token,
        viewingAgent._id,
        updateData
      );

      if (result.success) {
        // Update the agents list with the updated agent
        setAgents((prevAgents) =>
          prevAgents.map((agent) =>
            agent._id === viewingAgent._id ? { ...agent, ...updateData } : agent
          )
        );

        // Update the viewing agent in the modal
        setViewingAgent((prev) => ({ ...prev, ...updateData }));

        alert("Build ID guardado exitosamente en el agente");
        setBuildSuccessModal(false);
      } else {
        alert("Error al guardar el Build ID en el agente");
      }
    } catch (err) {
      console.error("Error saving build ID to agent:", err);
      alert("Error al guardar el Build ID en el agente: " + err.message);
    }
  };

  const openBulkTemplateModal = (whatsappAccount, agent) => {
    setSelectedWhatsAppAccount(whatsappAccount);
    setBulkTemplateAgent(agent);
    setBulkTemplateForm({
      templateName: "",
      excelFile: null,
      language: "es_MX",
    });
    setBulkTemplateError(null);
    setBulkTemplateSuccess(null);
    setBulkTemplateModal(true);
  };

  const closeBulkTemplateModal = () => {
    setBulkTemplateModal(false);
    setSelectedWhatsAppAccount(null);
    setBulkTemplateAgent(null);
    setBulkTemplateForm({
      templateName: "",
      excelFile: null,
      language: "es_MX",
    });
    setBulkTemplateError(null);
    setBulkTemplateSuccess(null);
    setBulkTemplateResults(null);
    setShowDetailedResults(false);
    setBulkTemplateProgress({
      currentBatch: 0,
      totalBatches: 0,
      currentSent: 0,
      currentFailed: 0,
      totalRecipients: 0
    });
  };

  const handleBulkTemplateFormChange = (field, value) => {
    setBulkTemplateForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // Test Agent handlers
  const openTestModal = async (formData, returnToSource = null) => {
    try {
      setTestModalReturnTo(returnToSource);
      if (returnToSource === "create") {
        setCreateModal(false);
      } else if (returnToSource === "edit") {
        setEditModal(false);
      }
      setTestModal(true);
      setTestInitializing(true);
      setTestError(null);
      setTestMessages([]);
      setTestSessionId(null);

      // Create test session with the form data
      const testData = {
        name: formData.name || "test_agent",
        system_instructions: formData.systemInstructions || "",
        model: formData.model || "gemini-2.5-pro",
        description: formData.description || "",
        tools: formData.tools || [],
        user_id: "test_user",
      };

      const result = await createTestSession(testData);

      if (result.success) {
        setTestSessionId(result.data.test_session_id);
        setTestMessages([
          {
            role: "system",
            content:
              "Test session started. You can now chat with the agent to test its behavior.",
          },
        ]);
      } else {
        setTestError(`Failed to create test session: ${result.error}`);
      }
    } catch (err) {
      setTestError(`Error opening test modal: ${err.message}`);
      console.error("Error opening test modal:", err);
    } finally {
      setTestInitializing(false);
    }
  };

  const closeTestModal = async () => {
    const returnTo = testModalReturnTo;
    setTestModalReturnTo(null);
    // Clean up test session if it exists
    if (testSessionId) {
      try {
        await deleteTestSession(testSessionId);
      } catch (err) {
        console.error("Error deleting test session:", err);
      }
    }
    setTestModal(false);
    setTestSessionId(null);
    setTestMessages([]);
    setTestError(null);
    setTestLoading(false);
    if (returnTo === "create") {
      setCreateModal(true);
    } else if (returnTo === "edit") {
      setEditModal(true);
    }
  };

  const handleTestSend = async (userMessage) => {
    const text = userMessage != null ? String(userMessage).trim() : "";
    if (!text || !testSessionId || testLoading) return;

    setTestLoading(true);
    setTestError(null);

    // Add user message to chat
    setTestMessages((prev) => [
      ...prev,
      {
        role: "user",
        content: text,
      },
    ]);

    try {
      const result = await sendTestMessage(testSessionId, text);

      if (result.success) {
        // Extract response from events
        let assistantResponse = "";
        const fullEventData = result.data.events || [];

        if (fullEventData.length > 0) {
          // Process events to extract text responses
          for (const event of fullEventData) {
            // Handle the structure: event.content.parts[0].text (Gemini format)
            if (event.content && event.content.parts) {
              for (const part of event.content.parts) {
                if (part.text) {
                  assistantResponse += part.text;
                }
              }
            }
            // Handle other event structures
            else if (event.text) {
              assistantResponse += event.text;
            } else if (event.content && typeof event.content === "string") {
              assistantResponse += event.content;
            } else if (event.message) {
              if (typeof event.message === "string") {
                assistantResponse += event.message;
              } else if (event.message.text) {
                assistantResponse += event.message.text;
              } else if (event.message.parts) {
                for (const part of event.message.parts) {
                  if (part.text) {
                    assistantResponse += part.text;
                  }
                }
              }
            } else if (event.response) {
              if (typeof event.response === "string") {
                assistantResponse += event.response;
              } else if (event.response.text) {
                assistantResponse += event.response.text;
              } else if (event.response.parts) {
                for (const part of event.response.parts) {
                  if (part.text) {
                    assistantResponse += part.text;
                  }
                }
              }
            } else if (event.type === "message" || event.type === "text") {
              if (event.data && event.data.text) {
                assistantResponse += event.data.text;
              }
            }
          }
        }

        // If no text found, show a helpful message
        if (!assistantResponse.trim()) {
          assistantResponse =
            "El agente respondió pero no se pudo extraer el texto. Haz clic para ver los detalles.";
          console.log("Agent events:", fullEventData);
        }

        setTestMessages((prev) => [
          ...prev,
          {
            role: "assistant",
            content: assistantResponse,
            rawData: fullEventData, // Store full event data for JSON viewing
          },
        ]);
      } else {
        setTestError(`Failed to send message: ${result.error}`);
        setTestMessages((prev) => [
          ...prev,
          {
            role: "error",
            content: `Error: ${result.error}`,
          },
        ]);
      }
    } catch (err) {
      setTestError(`Error sending message: ${err.message}`);
      setTestMessages((prev) => [
        ...prev,
        {
          role: "error",
          content: `Error: ${err.message}`,
        },
      ]);
      console.error("Error sending test message:", err);
    } finally {
      setTestLoading(false);
    }
  };

  const processExcelFile = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: "array" });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

          // Process the data with new structure
          // Row 0: Headers
          // Row 1: Type indicators (PARAMETER, CONTEXT, PHONE or empty)
          // Row 2+: Data rows
          const recipients = [];

          if (jsonData.length < 3) {
            throw new Error(
              "El archivo debe tener al menos 3 filas: encabezados, tipos y datos"
            );
          }

          const headers = jsonData[0];
          const typeRow = jsonData[1];

          // Find the phone number column (should be marked as PARAMETER)
          const phoneColumnIndex = typeRow.findIndex(
            (type) =>
              type === "PARAMETER" &&
              headers[typeRow.indexOf(type)]?.toLowerCase().includes("telefono")
          );
          if (phoneColumnIndex === -1) {
            throw new Error(
              "No se encontró una columna de teléfono marcada como PARAMETER"
            );
          }

          // Process data rows starting from index 2
          for (let i = 2; i < jsonData.length; i++) {
            const row = jsonData[i];
            if (row && row.length > 0 && row[phoneColumnIndex]) {
              const phoneNumber = row[phoneColumnIndex].toString().trim();
              if (phoneNumber) {
                const parameters = [];
                const context = {};

                // Process each column
                for (let j = 0; j < row.length; j++) {
                  if (
                    row[j] !== undefined &&
                    row[j] !== null &&
                    row[j] !== ""
                  ) {
                    const header = headers[j] || `Column_${j}`;
                    const type = typeRow[j];
                    const value = row[j].toString().trim();

                    if (type === "PARAMETER" && j !== phoneColumnIndex) {
                      parameters.push(value);
                    } else if (type === "CONTEXT") {
                      context[header] = value;
                    }
                  }
                }

                recipients.push({
                  phoneNumber,
                  parameters,
                  context,
                });
              }
            }
          }
          resolve(recipients);
        } catch (error) {
          reject(error);
        }
      };
      reader.onerror = () => reject(new Error("Error reading file"));
      reader.readAsArrayBuffer(file);
    });
  };

  const downloadTemplate = () => {
    // Create template structure
    const templateData = [
      // Headers row
      [
        "Telefono",
        "Nombre",
        "Email",
        "Empresa",
        "Producto",
        "Precio",
        "Fecha_Limite",
        "Notas_Adicionales",
      ],
      // Type indicators row
      [
        "PHONE",
        "PARAMETER",
        "CONTEXT",
        "CONTEXT",
        "PARAMETER",
        "PARAMETER",
        "PARAMETER",
        "CONTEXT",
      ],
      // Example data row
      [
        "1234567890",
        "Juan Pérez",
        "juan@empresa.com",
        "Empresa ABC",
        "Producto X",
        "$100",
        "2024-12-31",
        "Cliente VIP",
      ],
    ];

    // Create workbook and worksheet
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(templateData);

    // Style the header row
    const range = XLSX.utils.decode_range(ws["!ref"]);
    for (let C = range.s.c; C <= range.e.c; ++C) {
      const headerCell = XLSX.utils.encode_cell({ r: 0, c: C });
      if (!ws[headerCell]) continue;
      ws[headerCell].s = {
        font: { bold: true, color: { rgb: "FFFFFF" } },
        fill: { fgColor: { rgb: "366092" } },
      };
    }

    // Style the type row
    for (let C = range.s.c; C <= range.e.c; ++C) {
      const typeCell = XLSX.utils.encode_cell({ r: 1, c: C });
      if (!ws[typeCell]) continue;
      const cellValue = ws[typeCell].v;
      ws[typeCell].s = {
        font: { bold: true },
        fill: {
          fgColor: {
            rgb: cellValue === "PARAMETER" ? "E7F3FF" : "FFF2CC",
          },
        },
      };
    }

    // Add worksheet to workbook
    XLSX.utils.book_append_sheet(wb, ws, "Template");

    // Generate and download file
    XLSX.writeFile(wb, "template_bulk_whatsapp.xlsx");
  };

  const handleBulkTemplateSubmit = async () => {
    try {
      setBulkTemplateLoading(true);
      setBulkTemplateError(null);
      setBulkTemplateSuccess(null);
      setBulkTemplateResults(null);
      setShowDetailedResults(false);

      if (!bulkTemplateForm.templateName.trim()) {
        setBulkTemplateError("El nombre del template es requerido");
        setBulkTemplateLoading(false);
        return;
      }

      if (!bulkTemplateForm.excelFile) {
        setBulkTemplateError("El archivo Excel es requerido");
        setBulkTemplateLoading(false);
        return;
      }

      // Process Excel file
      const excelData = await processExcelFile(bulkTemplateForm.excelFile);

      if (!excelData || excelData.length === 0) {
        setBulkTemplateError(
          "No se encontraron datos válidos en el archivo Excel"
        );
        setBulkTemplateLoading(false);
        return;
      }

      // Initialize progress
      const batchSize = 10;
      const totalBatches = Math.ceil(excelData.length / batchSize);
      setBulkTemplateProgress({
        currentBatch: 0,
        totalBatches: totalBatches,
        currentSent: 0,
        currentFailed: 0,
        totalRecipients: excelData.length
      });

      // Send bulk templates with session creation
      const result = await sendBulkTemplates({
        agentId: bulkTemplateAgent._id,
        whatsappAccount: selectedWhatsAppAccount,
        templateName: bulkTemplateForm.templateName,
        language: bulkTemplateForm.language,
        recipients: excelData,
        token: props.token,
        onProgress: (currentBatch, totalBatches, currentSent, currentFailed) => {
          setBulkTemplateProgress({
            currentBatch,
            totalBatches,
            currentSent,
            currentFailed,
            totalRecipients: excelData.length
          });
        }
      });

      if (result.success) {
        const successMessage = `Se enviaron ${result.sent} templates exitosamente. ${result.failed} fallaron.`;
        setBulkTemplateSuccess(successMessage);
        setBulkTemplateResults({
          sent: result.sent,
          failed: result.failed,
          total: result.total,
          successfulPhoneNumbers: result.successfulPhoneNumbers || [],
          failedPhoneNumbers: result.failedPhoneNumbers || [],
          errors: result.errors || []
        });
        // Don't auto-close the modal - let user review results and close manually
        // This allows them to see detailed results without the modal closing
      } else {
        setBulkTemplateError(result.error || "Error al enviar los templates");
        setBulkTemplateResults(null);
      }
    } catch (err) {
      setBulkTemplateError("Error al procesar el envío masivo: " + err.message);
      console.error("Error sending bulk templates:", err);
    } finally {
      setBulkTemplateLoading(false);
    }
  };

  // Agent Manager functions
  const fetchDeployments = async () => {
    try {
      setDeploymentsLoading(true);
      setDeploymentsError(null);
      const result = await getDeployments();
      if (result.success) {
        setDeployments(result.data?.deployments || []);
      } else {
        setDeploymentsError("Error al cargar los despliegues");
      }
    } catch (err) {
      setDeploymentsError("Error al cargar los despliegues");
      console.error("Error fetching deployments:", err);
    } finally {
      setDeploymentsLoading(false);
    }
  };

  const handleDeleteDeployment = async (resourceId) => {
    if (
      !window.confirm(
        "¿Estás seguro de que quieres eliminar este despliegue? Esta acción no se puede deshacer."
      )
    ) {
      return;
    }

    try {
      setDeleteLoading(true);
      const result = await deleteDeployment(resourceId);
      if (result.success) {
        // Remove from list
        setDeployments((prev) =>
          prev.filter((dep) => {
            const id = dep.resource_name?.split("/").pop() || dep.resource_name;
            return id !== resourceId;
          })
        );
        alert("Despliegue eliminado exitosamente");
      } else {
        alert(`Error al eliminar el despliegue: ${result.error}`);
      }
    } catch (err) {
      alert(`Error al eliminar el despliegue: ${err.message}`);
      console.error("Error deleting deployment:", err);
    } finally {
      setDeleteLoading(false);
    }
  };

  const handleBatchDeleteDeployments = async () => {
    if (selectedDeployments.size === 0) {
      alert("Por favor selecciona al menos un despliegue para eliminar");
      return;
    }

    if (
      !window.confirm(
        `¿Estás seguro de que quieres eliminar ${selectedDeployments.size} despliegue(s)? Esta acción no se puede deshacer.`
      )
    ) {
      return;
    }

    try {
      setDeleteLoading(true);
      const resourceIds = Array.from(selectedDeployments);
      const result = await deleteDeploymentsBatch(resourceIds);
      if (result.success) {
        const { deleted_resources, failed_resources } = result.data;

        // Remove deleted deployments from list
        setDeployments((prev) =>
          prev.filter((dep) => {
            const id = dep.resource_name?.split("/").pop() || dep.resource_name;
            return !deleted_resources.includes(id);
          })
        );

        // Clear selection
        setSelectedDeployments(new Set());

        if (failed_resources && failed_resources.length > 0) {
          alert(
            `Se eliminaron ${deleted_resources.length} despliegue(s). ${failed_resources.length} fallaron.`
          );
        } else {
          alert(
            `Se eliminaron exitosamente ${deleted_resources.length} despliegue(s)`
          );
        }
      } else {
        alert(`Error al eliminar los despliegues: ${result.error}`);
      }
    } catch (err) {
      alert(`Error al eliminar los despliegues: ${err.message}`);
      console.error("Error deleting deployments in batch:", err);
    } finally {
      setDeleteLoading(false);
    }
  };

  const toggleDeploymentSelection = (resourceId) => {
    setSelectedDeployments((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(resourceId)) {
        newSet.delete(resourceId);
      } else {
        newSet.add(resourceId);
      }
      return newSet;
    });
  };

  const toggleSelectAll = () => {
    if (selectedDeployments.size === deployments.length) {
      setSelectedDeployments(new Set());
    } else {
      const allIds = deployments.map((dep) => {
        return dep.resource_name?.split("/").pop() || dep.resource_name;
      });
      setSelectedDeployments(new Set(allIds));
    }
  };

  const extractResourceId = (resourceName) => {
    if (!resourceName) return "N/A";
    return resourceName.split("/").pop() || resourceName;
  };

  // Typing in the create/edit forms updates state on this same top-level
  // component, which would otherwise force React to re-diff every agent
  // row on each keystroke. Memoizing the row list means that work is only
  // redone when the agents list or their edit-loading state actually change.
  const agentsTableRows = useMemo(() => {
    if (agents.length === 0) {
      return (
        <tr>
          <td colSpan="5" className="text-center text-muted">
            No hay agentes disponibles
          </td>
        </tr>
      );
    }
    return agents.map((agent) => (
      <tr key={agent.agentId || agent._id}>
        <td className="business-name">
          <strong>{agent.name || "Sin nombre"}</strong>
          {agent.proactiveEnabled ? (
            <span
              className="badge bg-info ms-2"
              title="Agente proactivo habilitado"
            >
              Proactivo
            </span>
          ) : null}
        </td>
        <td>
          {agent.description
            ? agent.description.length > 50
              ? `${agent.description.substring(0, 50)}...`
              : agent.description
            : "Sin descripción"}
        </td>
        <td>
          <span className="badge bg-light text-dark border border-secondary">
            {getAgentTypeLabel(agent.type)}
          </span>
        </td>
        <td>
          <span
            className={`badge bg-light text-dark border ${
              isCurrentlyActiveAgent(agent) ? "border-success" : "border-secondary"
            }`}
            style={{ color: "#212529" }}
            title={
              agent.isActive && !isCurrentlyActiveAgent(agent)
                ? "Expirado (fecha límite alcanzada)"
                : undefined
            }
          >
            {isCurrentlyActiveAgent(agent) ? "Activo" : "Inactivo"}
          </span>
        </td>
        <td>
          {getDeploymentStatusBadge(agent.deploymentStatus) || (
            <span className="text-muted">-</span>
          )}
        </td>
        <td className="actions-cell">
          <div className="d-flex align-items-center">
            <button
              className="view-button me-2"
              onClick={() => openViewModal(agent)}
              title="Ver detalles"
              style={{
                width: "40px",
                height: "40px",
                padding: "0",
                margin: "0",
                border: "none",
                borderRadius: "6px",
                backgroundColor: "#ff6b35",
                color: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                fontSize: "16px",
              }}
            >
              <i className="fas fa-eye" style={{ margin: "0", padding: "0" }} />
            </button>
            <button
              className="edit-button"
              onClick={() => openEditModal(agent)}
              disabled={editLoadingAgentId === agent._id}
              title="Editar"
              style={{
                width: "40px",
                height: "40px",
                padding: "0",
                margin: "0",
                border: "none",
                borderRadius: "6px",
                backgroundColor: "#343a40",
                color: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: editLoadingAgentId === agent._id ? "wait" : "pointer",
                fontSize: "16px",
              }}
            >
              {editLoadingAgentId === agent._id ? (
                <Spinner size="sm" style={{ width: "16px", height: "16px" }} />
              ) : (
                <i
                  className="fas fa-edit"
                  style={{ margin: "0", padding: "0" }}
                />
              )}
            </button>
          </div>
        </td>
      </tr>
    ));
    // eslint-disable-next-line react-hooks/exhaustive-deps -- openViewModal/openEditModal only close over stable setState functions and props.token, which practically never changes mid-session; getAgentTypeLabel/getDeploymentStatusBadge are pure and don't need to be deps
  }, [agents, editLoadingAgentId]);

  // Same rationale as agentsTableRows: the Agent Manager tab stays mounted
  // (reactstrap TabPane doesn't unmount inactive panes), so without this
  // memo every keystroke elsewhere in the page re-diffs this table too.
  const deploymentsTableRows = useMemo(
    () =>
      deployments.map((deployment, index) => {
        const resourceId = extractResourceId(deployment.resource_name);
        const isSelected = selectedDeployments.has(resourceId);
        return (
          <tr
            key={index}
            style={{
              backgroundColor: isSelected ? "#fff5f2" : "#ffffff",
              borderBottom: "1px solid #f0f0f0",
              transition: "all 0.2s ease",
            }}
            onMouseEnter={(e) => {
              if (!isSelected) {
                e.currentTarget.style.backgroundColor = "#f8f9fa";
              }
            }}
            onMouseLeave={(e) => {
              if (!isSelected) {
                e.currentTarget.style.backgroundColor = "#ffffff";
              }
            }}
          >
            <td style={{ padding: "16px", verticalAlign: "middle" }}>
              <Input
                type="checkbox"
                checked={isSelected}
                onChange={() => toggleDeploymentSelection(resourceId)}
                disabled={deleteLoading}
                style={{ cursor: "pointer", width: "18px", height: "18px" }}
              />
            </td>
            <td
              className="font-monospace"
              style={{ padding: "16px", verticalAlign: "middle" }}
            >
              <span
                style={{ color: "#2c3e50", fontWeight: "600", fontSize: "14px" }}
              >
                {resourceId}
              </span>
            </td>
            <td
              className="font-monospace"
              style={{ padding: "16px", verticalAlign: "middle" }}
            >
              <span
                style={{
                  color: "#6c757d",
                  fontSize: "13px",
                  wordBreak: "break-all",
                }}
              >
                {deployment.resource_name || "N/A"}
              </span>
            </td>
            <td
              className="actions-cell"
              style={{
                padding: "16px",
                verticalAlign: "middle",
                textAlign: "center",
              }}
            >
              <Button
                color="danger"
                size="sm"
                onClick={() => handleDeleteDeployment(resourceId)}
                disabled={deleteLoading}
                title="Eliminar"
                style={{
                  borderRadius: "6px",
                  width: "36px",
                  height: "36px",
                  padding: "0",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0 2px 4px rgba(220,53,69,0.2)",
                  transition: "all 0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "scale(1.05)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "scale(1)";
                }}
              >
                <i className="fas fa-trash"></i>
              </Button>
            </td>
          </tr>
        );
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps -- toggleDeploymentSelection/handleDeleteDeployment/extractResourceId only close over stable setState functions and props.token
    [deployments, selectedDeployments, deleteLoading]
  );

  const filteredMcpTools = mcpToolsListSearch.trim()
    ? mcpTools.filter((tool) => {
        const term = mcpToolsListSearch.trim().toLowerCase();
        return (
          tool.name?.toLowerCase().includes(term) ||
          tool.identifier?.toLowerCase().includes(term) ||
          tool.description?.toLowerCase().includes(term) ||
          tool.type?.toLowerCase().includes(term)
        );
      })
    : mcpTools;

  return (
    <div className="mantis-businesses-page">
      <PageHeader
        title="Agentes"
        subtitle="Gestión y administración de agentes de inteligencia artificial"
      />

      {/* Main Content */}
      <div className="page-content">
        {/* Add Create Agent Button */}
        <Row className="mb-3">
          <Col xs={12} className="d-flex justify-content-end">
            <Button
              color="primary"
              onClick={openCreateModal}
              style={{ backgroundColor: "#ff6b35", borderColor: "#ff6b35" }}
            >
              <i className="fas fa-plus me-2"></i>
              Crear Nuevo Agente
            </Button>
          </Col>
        </Row>

        {/* Navigation Tabs */}
        <Row>
          <Col xs={12}>
            <Nav tabs className="mb-4">
              <NavItem>
                <NavLink
                  className={activeTab === "agentes" ? "active" : ""}
                  onClick={() => toggleTab("agentes")}
                  style={{
                    color: activeTab === "agentes" ? "inherit" : "#ff6b35",
                  }}
                >
                  <i
                    className="fas fa-robot me-2"
                    style={{
                      color: activeTab === "agentes" ? "inherit" : "#ff6b35",
                    }}
                  ></i>
                  Agentes
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={activeTab === "sesiones" ? "active" : ""}
                  onClick={() => toggleTab("sesiones")}
                  style={{
                    color: activeTab === "sesiones" ? "inherit" : "#ff6b35",
                  }}
                >
                  <i
                    className="fas fa-comments me-2"
                    style={{
                      color: activeTab === "sesiones" ? "inherit" : "#ff6b35",
                    }}
                  ></i>
                  Sesiones
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={activeTab === "conversaciones" ? "active" : ""}
                  onClick={() => toggleTab("conversaciones")}
                  style={{
                    color:
                      activeTab === "conversaciones" ? "inherit" : "#ff6b35",
                  }}
                >
                  <i
                    className="fas fa-comment-dots me-2"
                    style={{
                      color:
                        activeTab === "conversaciones" ? "inherit" : "#ff6b35",
                    }}
                  ></i>
                  Conversaciones
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={activeTab === "agent-manager" ? "active" : ""}
                  onClick={() => toggleTab("agent-manager")}
                  style={{
                    color:
                      activeTab === "agent-manager" ? "inherit" : "#ff6b35",
                  }}
                >
                  <i
                    className="fas fa-cogs me-2"
                    style={{
                      color:
                        activeTab === "agent-manager" ? "inherit" : "#ff6b35",
                    }}
                  ></i>
                  Agent Manager
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={activeTab === "mcp-tools" ? "active" : ""}
                  onClick={() => toggleTab("mcp-tools")}
                  style={{
                    color: activeTab === "mcp-tools" ? "inherit" : "#ff6b35",
                  }}
                >
                  <i
                    className="fas fa-tools me-2"
                    style={{
                      color: activeTab === "mcp-tools" ? "inherit" : "#ff6b35",
                    }}
                  ></i>
                  MCP Tools
                </NavLink>
              </NavItem>
            </Nav>
          </Col>
        </Row>

        {/* Tab Content */}
        <TabContent activeTab={activeTab}>
          {/* Agentes Tab */}
          <TabPane tabId="agentes">
            {loading ? (
              <div className="loading-container">
                <Spinner color="primary" />
                <p>Cargando agentes...</p>
              </div>
            ) : error ? (
              <div className="error-container">
                <p className="text-danger">{error}</p>
                <button className="btn btn-primary" onClick={fetchAgents}>
                  Reintentar
                </button>
              </div>
            ) : (
              <Row>
                <Col xs={12}>
                  <Card className="businesses-card">
                    <CardBody>
                      <Table responsive className="businesses-table">
                        <thead>
                          <tr>
                            <th>Nombre</th>
                            <th>Descripción</th>
                            <th>Tipo</th>
                            <th>Estado</th>
                            <th>Despliegue</th>
                            <th>Acciones</th>
                          </tr>
                        </thead>
                        <tbody>{agentsTableRows}</tbody>
                      </Table>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            )}
          </TabPane>

          {/* Sesiones Tab */}
          <TabPane tabId="sesiones">
            {sessionsTabLoaded && <Sessions />}
          </TabPane>

          {/* Conversaciones Tab */}
          <TabPane tabId="conversaciones">
            {conversationsTabLoaded && <Conversations />}
          </TabPane>

          {/* Agent Manager Tab */}
          <TabPane tabId="agent-manager">
            {deploymentsLoading ? (
              <div className="loading-container">
                <Spinner color="primary" />
                <p>Cargando despliegues...</p>
              </div>
            ) : deploymentsError ? (
              <div className="error-container">
                <p className="text-danger">{deploymentsError}</p>
                <button className="btn btn-primary" onClick={fetchDeployments}>
                  Reintentar
                </button>
              </div>
            ) : (
              <Row>
                <Col xs={12}>
                  <Card
                    className="businesses-card"
                    style={{
                      border: "none",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                      borderRadius: "12px",
                      overflow: "hidden",
                    }}
                  >
                    {/* Header Section */}
                    <div
                      style={{
                        backgroundColor: "#ffffff",
                        padding: "24px",
                        borderBottom: "2px solid #f0f0f0",
                        borderRadius: "12px 12px 0 0",
                      }}
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center">
                          <div
                            style={{
                              width: "48px",
                              height: "48px",
                              borderRadius: "12px",
                              backgroundColor: "#ff6b35",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              marginRight: "16px",
                            }}
                          >
                            <i
                              className="fas fa-cogs"
                              style={{ color: "#ffffff", fontSize: "20px" }}
                            ></i>
                          </div>
                          <div>
                            <h5
                              className="mb-0"
                              style={{
                                color: "#2c3e50",
                                fontWeight: "600",
                                fontSize: "20px",
                              }}
                            >
                              Despliegues de Agentes
                            </h5>
                            <small
                              className="text-muted"
                              style={{ fontSize: "13px" }}
                            >
                              {deployments.length} despliegue
                              {deployments.length !== 1 ? "s" : ""} disponible
                              {deployments.length !== 1 ? "s" : ""}
                            </small>
                          </div>
                        </div>
                        <div className="d-flex gap-2">
                          <Button
                            style={{
                              backgroundColor: "#ff6b35",
                              borderColor: "#ff6b35",
                              borderRadius: "8px",
                              padding: "8px 20px",
                              fontWeight: "500",
                              boxShadow: "0 2px 4px rgba(255,107,53,0.2)",
                            }}
                            size="sm"
                            onClick={fetchDeployments}
                            disabled={deploymentsLoading}
                          >
                            <i className="fas fa-sync-alt me-2"></i>
                            Actualizar
                          </Button>
                          {selectedDeployments.size > 0 && (
                            <Button
                              color="danger"
                              size="sm"
                              onClick={handleBatchDeleteDeployments}
                              disabled={deleteLoading}
                              style={{
                                borderRadius: "8px",
                                padding: "8px 20px",
                                fontWeight: "500",
                                boxShadow: "0 2px 4px rgba(220,53,69,0.2)",
                              }}
                            >
                              <i className="fas fa-trash me-2"></i>
                              Eliminar ({selectedDeployments.size})
                            </Button>
                          )}
                        </div>
                      </div>
                    </div>

                    <CardBody style={{ padding: "0" }}>
                      {deployments.length > 0 ? (
                        <div style={{ overflowX: "auto" }}>
                          <Table
                            responsive
                            className="mb-0"
                            style={{
                              marginBottom: "0",
                            }}
                          >
                            <thead>
                              <tr
                                style={{
                                  backgroundColor: "#ff6b35",
                                  color: "#ffffff",
                                }}
                              >
                                <th
                                  style={{
                                    width: "60px",
                                    padding: "16px",
                                    fontWeight: "600",
                                    fontSize: "13px",
                                    textTransform: "uppercase",
                                    letterSpacing: "0.5px",
                                    border: "none",
                                  }}
                                >
                                  <Input
                                    type="checkbox"
                                    checked={
                                      selectedDeployments.size ===
                                        deployments.length &&
                                      deployments.length > 0
                                    }
                                    onChange={toggleSelectAll}
                                    disabled={deleteLoading}
                                    style={{
                                      cursor: "pointer",
                                      width: "18px",
                                      height: "18px",
                                    }}
                                  />
                                </th>
                                <th
                                  style={{
                                    padding: "16px",
                                    fontWeight: "600",
                                    fontSize: "13px",
                                    textTransform: "uppercase",
                                    letterSpacing: "0.5px",
                                    border: "none",
                                  }}
                                >
                                  Resource ID
                                </th>
                                <th
                                  style={{
                                    padding: "16px",
                                    fontWeight: "600",
                                    fontSize: "13px",
                                    textTransform: "uppercase",
                                    letterSpacing: "0.5px",
                                    border: "none",
                                  }}
                                >
                                  Resource Name
                                </th>
                                <th
                                  style={{
                                    padding: "16px",
                                    fontWeight: "600",
                                    fontSize: "13px",
                                    textTransform: "uppercase",
                                    letterSpacing: "0.5px",
                                    border: "none",
                                    textAlign: "center",
                                    width: "120px",
                                  }}
                                >
                                  Acciones
                                </th>
                              </tr>
                            </thead>
                            <tbody>{deploymentsTableRows}</tbody>
                          </Table>
                        </div>
                      ) : (
                        <div
                          className="text-center text-muted"
                          style={{
                            padding: "60px 20px",
                            backgroundColor: "#f8f9fa",
                          }}
                        >
                          <div
                            style={{
                              width: "80px",
                              height: "80px",
                              borderRadius: "50%",
                              backgroundColor: "#e9ecef",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              margin: "0 auto 20px",
                            }}
                          >
                            <i
                              className="fas fa-cogs"
                              style={{
                                fontSize: "32px",
                                color: "#6c757d",
                              }}
                            ></i>
                          </div>
                          <h5
                            style={{
                              color: "#495057",
                              fontWeight: "600",
                              marginBottom: "8px",
                            }}
                          >
                            No hay despliegues disponibles
                          </h5>
                          <p
                            className="small"
                            style={{ color: "#6c757d", marginBottom: "0" }}
                          >
                            Los despliegues de agentes aparecerán aquí cuando se
                            creen
                          </p>
                        </div>
                      )}
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            )}
          </TabPane>

          {/* MCP Tools Tab */}
          <TabPane tabId="mcp-tools">
            {mcpToolsLoading ? (
              <div className="loading-container">
                <Spinner color="primary" />
                <p>Cargando herramientas MCP...</p>
              </div>
            ) : mcpToolsError ? (
              <div className="error-container">
                <p className="text-danger">{mcpToolsError}</p>
                <button className="btn btn-primary" onClick={fetchMCPTools}>
                  Reintentar
                </button>
              </div>
            ) : (
              <Row>
                <Col xs={12}>
                  <Card
                    className="businesses-card"
                    style={{
                      border: "none",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                      borderRadius: "12px",
                      overflow: "hidden",
                    }}
                  >
                    {/* Header Section */}
                    <div
                      style={{
                        backgroundColor: "#ffffff",
                        padding: "24px",
                        borderBottom: "2px solid #f0f0f0",
                        borderRadius: "12px 12px 0 0",
                      }}
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center">
                          <div
                            style={{
                              width: "48px",
                              height: "48px",
                              borderRadius: "12px",
                              backgroundColor: "#ff6b35",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              marginRight: "16px",
                            }}
                          >
                            <i
                              className="fas fa-tools"
                              style={{ color: "#ffffff", fontSize: "20px" }}
                            ></i>
                          </div>
                          <div>
                            <h5
                              className="mb-0"
                              style={{
                                color: "#2c3e50",
                                fontWeight: "600",
                                fontSize: "20px",
                              }}
                            >
                              Herramientas MCP
                            </h5>
                            <small
                              className="text-muted"
                              style={{ fontSize: "13px" }}
                            >
                              {mcpToolsListSearch.trim()
                                ? `${filteredMcpTools.length} de ${mcpTools.length} herramientas`
                                : `${mcpTools.length} herramienta${
                                    mcpTools.length !== 1 ? "s" : ""
                                  } disponible${
                                    mcpTools.length !== 1 ? "s" : ""
                                  }`}
                            </small>
                          </div>
                        </div>
                        <div className="d-flex gap-2 align-items-center">
                          <div style={{ position: "relative" }}>
                            <i
                              className="fas fa-search"
                              style={{
                                position: "absolute",
                                left: "12px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                color: "#adb5bd",
                                fontSize: "13px",
                                pointerEvents: "none",
                              }}
                            ></i>
                            <Input
                              type="text"
                              value={mcpToolsListSearch}
                              onChange={(e) =>
                                setMcpToolsListSearch(e.target.value)
                              }
                              placeholder="Buscar herramienta..."
                              bsSize="sm"
                              style={{
                                paddingLeft: "34px",
                                paddingRight: mcpToolsListSearch ? "30px" : "12px",
                                borderRadius: "8px",
                                minWidth: "240px",
                              }}
                            />
                            {mcpToolsListSearch && (
                              <button
                                type="button"
                                onClick={() => setMcpToolsListSearch("")}
                                title="Limpiar búsqueda"
                                style={{
                                  position: "absolute",
                                  right: "8px",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  border: "none",
                                  background: "none",
                                  color: "#adb5bd",
                                  cursor: "pointer",
                                  padding: 0,
                                  lineHeight: 1,
                                }}
                              >
                                <i className="fas fa-times"></i>
                              </button>
                            )}
                          </div>
                          <Button
                            style={{
                              backgroundColor: "#ff6b35",
                              borderColor: "#ff6b35",
                              borderRadius: "8px",
                              padding: "8px 20px",
                              fontWeight: "500",
                              boxShadow: "0 2px 4px rgba(255,107,53,0.2)",
                              whiteSpace: "nowrap",
                            }}
                            size="sm"
                            onClick={() => openMcpToolModal()}
                          >
                            <i className="fas fa-plus me-2"></i>
                            Nueva Herramienta
                          </Button>
                        </div>
                      </div>
                    </div>
                    <CardBody>
                      <Table responsive className="businesses-table">
                        <thead>
                          <tr>
                            <th>Nombre</th>
                            <th>Identificador</th>
                            <th>Tipo</th>
                            <th>Descripción</th>
                            <th>Fecha de Creación</th>
                            <th>Acciones</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredMcpTools.length > 0 ? (
                            filteredMcpTools.map((tool) => (
                              <tr key={tool._id}>
                                <td>
                                  <strong>{tool.name}</strong>
                                </td>
                                <td>
                                  <code>{tool.identifier}</code>
                                </td>
                                <td>
                                  <span
                                    className={`badge ${
                                      tool.type === "http"
                                        ? "bg-info"
                                        : "bg-secondary"
                                    }`}
                                  >
                                    {tool.type === "http" ? "HTTP" : "Integrada"}
                                  </span>
                                </td>
                                <td>
                                  {tool.description ? (
                                    <span title={tool.description}>
                                      {tool.description.length > 50
                                        ? `${tool.description.substring(
                                            0,
                                            50
                                          )}...`
                                        : tool.description}
                                    </span>
                                  ) : (
                                    <span className="text-muted">
                                      Sin descripción
                                    </span>
                                  )}
                                </td>
                                <td>
                                  {new Date(
                                    tool.dateCreated
                                  ).toLocaleDateString("es-ES", {
                                    year: "numeric",
                                    month: "short",
                                    day: "numeric",
                                  })}
                                </td>
                                <td>
                                  <div className="d-flex gap-2">
                                    <Button
                                      color="secondary"
                                      size="sm"
                                      onClick={() => openMcpToolModal(tool)}
                                      title="Editar"
                                    >
                                      <i className="fas fa-edit"></i>
                                    </Button>
                                    <Button
                                      color="danger"
                                      size="sm"
                                      onClick={() =>
                                        handleDeleteMcpTool(tool._id)
                                      }
                                      title="Eliminar"
                                    >
                                      <i className="fas fa-trash"></i>
                                    </Button>
                                  </div>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td
                                colSpan="6"
                                className="text-center text-muted"
                              >
                                {mcpToolsListSearch.trim()
                                  ? `No hay herramientas que coincidan con "${mcpToolsListSearch}"`
                                  : "No hay herramientas MCP disponibles"}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            )}
          </TabPane>
        </TabContent>
      </div>

      {/* Create Agent Modal */}
      <Modal
        isOpen={createModal}
        toggle={createLoading ? undefined : closeCreateModal}
        size="xl"
        backdrop={createLoading ? "static" : true}
        keyboard={!createLoading}
      >
        <ModalHeader toggle={createLoading ? undefined : closeCreateModal}>
          <i className="fas fa-plus me-2"></i>
          Crear Nuevo Agente
          {createLoading && (
            <span className="ms-2">
              <i className="fas fa-spinner fa-spin me-2"></i>
              Creando...
            </span>
          )}
        </ModalHeader>
        <ModalBody style={{ position: "relative", overflow: "visible" }}>
          {createLoading && (
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(255, 255, 255, 0.9)",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 1000,
                borderRadius: "0.25rem",
              }}
            >
              <Spinner
                color="primary"
                style={{ width: "3rem", height: "3rem" }}
              />
              <p
                className="mt-3 mb-0"
                style={{ fontSize: "1.1rem", fontWeight: "500" }}
              >
                Creando agente y desplegando...
              </p>
              <p className="text-muted mt-2" style={{ fontSize: "0.9rem" }}>
                Esto puede tomar varios minutos
              </p>
            </div>
          )}
          {createError && (
            <Alert color="danger" className="mb-3">
              {createError}
            </Alert>
          )}

          <Form>
            {/* Basic Information */}
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="agentName">Nombre *</Label>
                  <Input
                    id="agentName"
                    type="text"
                    value={createForm.name}
                    onChange={(e) =>
                      handleCreateFormChange("name", e.target.value)
                    }
                    placeholder="Nombre del agente"
                    required
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="agentType">Tipo *</Label>
                  <Input
                    id="agentType"
                    type="select"
                    value={createForm.type}
                    onChange={(e) =>
                      handleCreateFormChange("type", e.target.value)
                    }
                  >
                    <option value="GENERAL">General</option>
                    <option value="INITIAL_PURCHASE_REQUESTS">
                      Solicitudes de Compra
                    </option>
                    <option value="SUPPLIER_QUOTATIONS">
                      Cotizaciones de Proveedores
                    </option>
                    <option value="WHATSAPP_SUPPLIER_QUOTATIONS">
                      Cotizaciones WhatsApp
                    </option>
                  </Input>
                </FormGroup>
              </Col>
            </Row>

            {/* Agent ID and Model */}
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="agentId">ID del Agente</Label>
                  <Input
                    id="agentId"
                    type="text"
                    value={createForm.agentId}
                    onChange={(e) =>
                      handleCreateFormChange("agentId", e.target.value)
                    }
                    placeholder="ID único del agente desplegado (opcional)"
                  />
                  <small className="text-muted">
                    Si está vacío, se creará automáticamente un nuevo
                    despliegue. Si está lleno, se usará este ID existente.
                  </small>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="agentModel">Modelo LLM *</Label>
                  <Input
                    id="agentModel"
                    type="select"
                    value={createForm.model}
                    onChange={(e) =>
                      handleCreateFormChange("model", e.target.value)
                    }
                    required
                  >
                    <option value="gemini-2.5-pro">Gemini 2.5 Pro</option>
                    <option value="gemini-2.0-flash">Gemini 2.0 Flash</option>
                    <option value="claude-haiku-4-5-20251001">Claude Haiku 4.5</option>
                    <option value="claude-sonnet-4-6">Claude Sonnet 4.6</option>
                    <option value="claude-opus-4-8">Claude Opus 4.8</option>
                  </Input>
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="agentCacheTime">Tiempo de Caché (segundos)</Label>
                  <Input
                    id="agentCacheTime"
                    type="number"
                    min="0"
                    value={createForm.cacheTime}
                    onChange={(e) =>
                      handleCreateFormChange(
                        "cacheTime",
                        parseInt(e.target.value) || 0
                      )
                    }
                    placeholder="10"
                  />
                  <small className="text-muted">
                    Tiempo en segundos que el agente esperará antes de procesar
                    mensajes agrupados. Si es 0, los mensajes se procesan
                    inmediatamente. Valor por defecto: 10 segundos.
                  </small>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label check className="d-block mb-2">
                    <Input
                      type="checkbox"
                      checked={!!createForm.proactiveEnabled}
                      onChange={(e) =>
                        handleCreateFormChange(
                          "proactiveEnabled",
                          e.target.checked
                        )
                      }
                    />{" "}
                    Agente proactivo (recordatorios / seguimiento programado)
                  </Label>
                  <small className="text-muted d-block mb-2">
                    Permite que el agente programe turnos diferidos vía la
                    herramienta MCP cuando el usuario pide un recordatorio. Debe
                    estar habilitado en Mantis y configurar herramientas MCP.
                  </small>
                  {createForm.proactiveEnabled && (
                    <>
                      <Label for="createProactiveMaxDelay">
                        Retraso máximo permitido (minutos)
                      </Label>
                      <Input
                        id="createProactiveMaxDelay"
                        type="number"
                        min={1}
                        max={999999}
                        value={createForm.proactiveMaxDelayMinutes}
                        onChange={(e) =>
                          handleCreateFormChange(
                            "proactiveMaxDelayMinutes",
                            parseInt(e.target.value, 10) || 1
                          )
                        }
                      />
                      <small className="text-muted">
                        Límite superior que el servidor aplicará a{" "}
                        <code>delay_seconds</code> o <code>run_at</code> al
                        programar (por defecto 10080 = 7 días).
                      </small>
                    </>
                  )}
                </FormGroup>
              </Col>
            </Row>

            <FormGroup check className="mb-3">
              <Label check>
                <Input
                  type="checkbox"
                  checked={scheduleDeactivationCreate}
                  onChange={(e) => setScheduleDeactivationCreate(e.target.checked)}
                />{" "}
                Programar desactivación automática (expiración)
              </Label>
            </FormGroup>

            {scheduleDeactivationCreate && (
              <FormGroup>
                <Label for="agentActiveTo">Activo hasta</Label>
                <Input
                  id="agentActiveTo"
                  type="date"
                  value={createForm.activeTo}
                  onChange={(e) =>
                    handleCreateFormChange("activeTo", e.target.value)
                  }
                />
                <small className="text-muted">
                  A partir de esta fecha el agente se tratará como inactivo
                  automáticamente, sin necesidad de desactivarlo manualmente.
                </small>
              </FormGroup>
            )}

            <FormGroup>
              <Label for="agentFallbackMessage">
                Mensaje cuando el agente está inactivo
              </Label>
              <Input
                id="agentFallbackMessage"
                type="textarea"
                rows="2"
                value={createForm.fallbackMessage}
                onChange={(e) =>
                  handleCreateFormChange("fallbackMessage", e.target.value)
                }
                placeholder="Ej: Para hablar con nosotros escríbenos al 310 7641654"
              />
              <small className="text-muted">
                Se envía al usuario en lugar de ejecutar el flujo del agente
                cuando el agente está desactivado (manualmente o por la fecha
                de expiración de arriba). Si se deja vacío, no se envía
                ninguna respuesta.
              </small>
            </FormGroup>

            <FormGroup>
              <Label for="agentDescription">Descripción</Label>
              <Input
                id="agentDescription"
                type="textarea"
                rows="3"
                value={createForm.description}
                onChange={(e) =>
                  handleCreateFormChange("description", e.target.value)
                }
                placeholder="Descripción del agente"
              />
            </FormGroup>

            <FormGroup>
              <Label for="systemInstructions">
                Instrucciones del Sistema *
              </Label>
              <Input
                id="systemInstructions"
                type="textarea"
                rows="6"
                value={createForm.systemInstructions}
                onChange={(e) =>
                  handleCreateFormChange("systemInstructions", e.target.value)
                }
                placeholder="Instrucciones del sistema para el agente"
                required
              />
            </FormGroup>

            {/* Database Connections Section */}
            <hr className="my-4" />
            <h5 className="mb-3">
              <i className="fas fa-database me-2 text-primary"></i>
              Conexiones de Base de Datos
            </h5>
            <DatabaseConnectionsForm
              connections={createForm.databaseConnections}
              onChange={(connections) =>
                handleCreateFormChange("databaseConnections", connections)
              }
            />

            {/* WhatsApp Accounts Section */}
            <hr className="my-4" />
            <h5 className="mb-3">
              <i className="fab fa-whatsapp me-2 text-success"></i>
              Cuentas de WhatsApp
            </h5>
            <WhatsAppAccountsForm
              accounts={createForm.whatsappAccounts}
              onChange={(accounts) =>
                handleCreateFormChange("whatsappAccounts", accounts)
              }
              agentId={null}
              token={props.token}
            />

            {/* MCP Tools Section */}
            <hr className="my-4" />
            <h5 className="mb-3">
              <i className="fas fa-tools me-2 text-warning"></i>
              Herramientas MCP
            </h5>
            <FormGroup>
              <Label>Seleccionar Herramientas MCP</Label>
              {createForm.proactiveEnabled && (
                <small className="text-muted d-block mb-2">
                  Incluye la herramienta{" "}
                  <code>schedule_proactive_follow_up_tool</code> si limitas la
                  lista; si la lista está vacía, el agente puede usar todas las
                  herramientas disponibles en MCP.
                </small>
              )}
              <div style={{ position: "relative", overflow: "visible" }} data-mcp-tools-dropdown>
                <div
                  onClick={() => {
                    setMcpToolsDropdownOpen(!mcpToolsDropdownOpen);
                    if (!mcpToolsDropdownOpen) {
                      setMcpToolsSearch(""); // Clear search when opening
                    }
                  }}
                  style={{
                    border: "1px solid #ced4da",
                    borderRadius: "0.25rem",
                    padding: "0.5rem 0.75rem",
                    minHeight: "38px",
                    backgroundColor: "#fff",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    flexWrap: "wrap",
                    gap: "0.5rem",
                    position: "relative",
                    zIndex: 10,
                  }}
                >
                  {createForm.tools && createForm.tools.length > 0 ? (
                    createForm.tools.map((toolId) => {
                      const tool = mcpTools.find(
                        (t) => t.identifier === toolId
                      );
                      return tool ? (
                        <span
                          key={toolId}
                          className="badge"
                          style={{
                            backgroundColor: "#ff6b35",
                            color: "#fff",
                            padding: "0.35em 0.65em",
                            fontSize: "0.875em",
                            borderRadius: "0.25rem",
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "0.5rem",
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleCreateFormChange(
                              "tools",
                              createForm.tools.filter((id) => id !== toolId)
                            );
                          }}
                        >
                          {tool.name}
                          <i
                            className="fas fa-times"
                            style={{ cursor: "pointer", fontSize: "0.75em" }}
                          ></i>
                        </span>
                      ) : null;
                    })
                  ) : (
                    <span style={{ color: "#6c757d" }}>
                      Selecciona herramientas MCP...
                    </span>
                  )}
                  <i
                    className={`fas fa-chevron-${
                      mcpToolsDropdownOpen ? "up" : "down"
                    }`}
                    style={{
                      marginLeft: "auto",
                      color: "#6c757d",
                    }}
                  ></i>
                </div>
                {mcpToolsDropdownOpen && (
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      right: 0,
                      backgroundColor: "#fff",
                      border: "1px solid #ced4da",
                      borderTop: "none",
                      borderRadius: "0 0 0.25rem 0.25rem",
                      maxHeight: "250px",
                      overflowY: "auto",
                      overflowX: "hidden",
                      zIndex: 1001,
                      boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                      marginTop: "-1px",
                      maxWidth: "100%",
                    }}
                  >
                    {/* Search Input */}
                    <div
                      style={{
                        padding: "0.5rem",
                        borderBottom: "1px solid #f0f0f0",
                      }}
                    >
                      <Input
                        type="text"
                        placeholder="Buscar herramientas..."
                        value={mcpToolsSearch}
                        onChange={(e) => {
                          e.stopPropagation();
                          setMcpToolsSearch(e.target.value);
                        }}
                        onClick={(e) => e.stopPropagation()}
                        style={{
                          fontSize: "0.875rem",
                          padding: "0.375rem 0.75rem",
                        }}
                      />
                    </div>
                    {mcpTools.length > 0 ? (
                      (() => {
                        const filteredTools = mcpToolsSearch.trim()
                          ? mcpTools.filter((tool) => {
                              const searchLower = mcpToolsSearch.toLowerCase();
                              return (
                                tool.name.toLowerCase().includes(searchLower) ||
                                tool.identifier
                                  .toLowerCase()
                                  .includes(searchLower) ||
                                (tool.description &&
                                  tool.description
                                    .toLowerCase()
                                    .includes(searchLower))
                              );
                            })
                          : mcpTools;

                        return filteredTools.length > 0 ? (
                          filteredTools.map((tool) => {
                            const isSelected =
                              createForm.tools &&
                              createForm.tools.includes(tool.identifier);
                            return (
                              <div
                                key={tool._id}
                                onClick={() => {
                                  const currentTools = createForm.tools || [];
                                  if (isSelected) {
                                    handleCreateFormChange(
                                      "tools",
                                      currentTools.filter(
                                        (id) => id !== tool.identifier
                                      )
                                    );
                                  } else {
                                    handleCreateFormChange("tools", [
                                      ...currentTools,
                                      tool.identifier,
                                    ]);
                                  }
                                }}
                                style={{
                                  padding: "0.75rem 1rem",
                                  cursor: "pointer",
                                  backgroundColor: isSelected
                                    ? "#f8f9fa"
                                    : "#fff",
                                  borderBottom: "1px solid #f0f0f0",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "0.75rem",
                                  transition: "background-color 0.2s",
                                }}
                                onMouseEnter={(e) => {
                                  if (!isSelected)
                                    e.currentTarget.style.backgroundColor =
                                      "#f8f9fa";
                                }}
                                onMouseLeave={(e) => {
                                  if (!isSelected)
                                    e.currentTarget.style.backgroundColor =
                                      "#fff";
                                }}
                              >
                                <input
                                  type="checkbox"
                                  checked={isSelected}
                                  onChange={() => {}}
                                  style={{
                                    cursor: "pointer",
                                    width: "18px",
                                    height: "18px",
                                  }}
                                />
                                <div style={{ flex: 1 }}>
                                  <div
                                    style={{
                                      fontWeight: "500",
                                      color: "#2c3e50",
                                    }}
                                  >
                                    {tool.name}
                                  </div>
                                  <div
                                    style={{
                                      fontSize: "0.875em",
                                      color: "#6c757d",
                                    }}
                                  >
                                    <code>{tool.identifier}</code>
                                  </div>
                                  {tool.description && (
                                    <div
                                      style={{
                                        fontSize: "0.75em",
                                        color: "#868e96",
                                        marginTop: "0.25rem",
                                      }}
                                    >
                                      {tool.description.length > 60
                                        ? `${tool.description.substring(
                                            0,
                                            60
                                          )}...`
                                        : tool.description}
                                    </div>
                                  )}
                                </div>
                              </div>
                            );
                          })
                        ) : (
                          <div
                            style={{
                              padding: "1rem",
                              textAlign: "center",
                              color: "#6c757d",
                            }}
                          >
                            No se encontraron herramientas que coincidan con "
                            {mcpToolsSearch}"
                          </div>
                        );
                      })()
                    ) : (
                      <div
                        style={{
                          padding: "1rem",
                          textAlign: "center",
                          color: "#6c757d",
                        }}
                      >
                        No hay herramientas disponibles
                      </div>
                    )}
                  </div>
                )}
              </div>
              <small className="text-muted d-block mt-2">
                Si no seleccionas ninguna, el agente tendrá acceso a todas las
                herramientas disponibles.
              </small>
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button
            type="button"
            color="info"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              openTestModal(createForm, "create");
            }}
            disabled={
              createLoading ||
              !createForm.name.trim() ||
              !createForm.systemInstructions.trim() ||
              !createForm.model.trim()
            }
            style={{ marginRight: "auto" }}
          >
            <i className="fas fa-vial me-2"></i>
            Probar Agente
          </Button>
          <Button
            color="secondary"
            onClick={closeCreateModal}
            disabled={createLoading}
          >
            Cancelar
          </Button>
          <Button
            color="primary"
            onClick={handleCreateSubmit}
            disabled={
              createLoading ||
              !createForm.name.trim() ||
              !createForm.systemInstructions.trim() ||
              !createForm.model.trim()
            }
          >
            {createLoading ? (
              <>
                <Spinner size="sm" className="me-2" />
                Creando...
              </>
            ) : (
              "Crear Agente"
            )}
          </Button>
        </ModalFooter>
      </Modal>

      {/* Edit Agent Modal */}
      <Modal
        isOpen={editModal}
        toggle={redeployLoading ? undefined : closeEditModal}
        size="xl"
        backdrop={redeployLoading ? "static" : true}
        keyboard={!redeployLoading}
      >
        <ModalHeader toggle={redeployLoading ? undefined : closeEditModal}>
          <i className="fas fa-edit me-2"></i>
          Editar Agente: {editingAgent?.name}
          {redeployLoading && (
            <span className="ms-2">
              <i className="fas fa-spinner fa-spin me-2"></i>
              Redesplegando...
            </span>
          )}
        </ModalHeader>
        <ModalBody style={{ position: "relative" }}>
          {redeployLoading && (
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(255, 255, 255, 0.9)",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 1000,
                borderRadius: "0.25rem",
              }}
            >
              <Spinner
                color="primary"
                style={{ width: "3rem", height: "3rem" }}
              />
              <p
                className="mt-3 mb-0"
                style={{ fontSize: "1.1rem", fontWeight: "500" }}
              >
                Actualizando agente y redesplegando...
              </p>
              <p className="text-muted mt-2" style={{ fontSize: "0.9rem" }}>
                Esto puede tomar varios minutos
              </p>
            </div>
          )}
          {editError && (
            <Alert color="danger" className="mb-3">
              {editError}
            </Alert>
          )}

          <Form>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="agentName">Nombre *</Label>
                  <Input
                    id="agentName"
                    type="text"
                    value={editForm.name}
                    onChange={(e) =>
                      handleEditFormChange("name", e.target.value)
                    }
                    placeholder="Nombre del agente"
                    required
                    disabled={redeployLoading}
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="agentType">Tipo *</Label>
                  <Input
                    id="agentType"
                    type="select"
                    value={editForm.type}
                    onChange={(e) =>
                      handleEditFormChange("type", e.target.value)
                    }
                    disabled={redeployLoading}
                  >
                    <option value="GENERAL">General</option>
                    <option value="INITIAL_PURCHASE_REQUESTS">
                      Solicitudes de Compra
                    </option>
                    <option value="SUPPLIER_QUOTATIONS">
                      Cotizaciones de Proveedores
                    </option>
                    <option value="WHATSAPP_SUPPLIER_QUOTATIONS">
                      Cotizaciones WhatsApp
                    </option>
                  </Input>
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="agentId">ID del Agente</Label>
                  <Input
                    id="agentId"
                    type="text"
                    value={editForm.agentId}
                    onChange={(e) =>
                      handleEditFormChange("agentId", e.target.value)
                    }
                    placeholder="ID único del agente"
                    disabled={redeployLoading}
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="agentModel">Modelo LLM *</Label>
                  <Input
                    id="agentModel"
                    type="select"
                    value={editForm.model}
                    onChange={(e) =>
                      handleEditFormChange("model", e.target.value)
                    }
                    required
                    disabled={redeployLoading}
                  >
                    <option value="gemini-2.5-pro">Gemini 2.5 Pro</option>
                    <option value="gemini-2.0-flash">Gemini 2.0 Flash</option>
                    <option value="claude-haiku-4-5-20251001">Claude Haiku 4.5</option>
                    <option value="claude-sonnet-4-6">Claude Sonnet 4.6</option>
                    <option value="claude-opus-4-8">Claude Opus 4.8</option>
                  </Input>
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="agentCacheTime">Tiempo de Caché (segundos)</Label>
                  <Input
                    id="agentCacheTime"
                    type="number"
                    min="0"
                    value={editForm.cacheTime}
                    onChange={(e) =>
                      handleEditFormChange(
                        "cacheTime",
                        parseInt(e.target.value) || 0
                      )
                    }
                    placeholder="30"
                    disabled={redeployLoading}
                  />
                  <small className="text-muted">
                    Tiempo en segundos que el agente esperará antes de procesar
                    mensajes agrupados. Si es 0, los mensajes se procesan
                    inmediatamente. Valor por defecto: 30 segundos.
                  </small>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label check className="d-block mb-2">
                    <Input
                      type="checkbox"
                      checked={!!editForm.proactiveEnabled}
                      onChange={(e) =>
                        handleEditFormChange(
                          "proactiveEnabled",
                          e.target.checked
                        )
                      }
                      disabled={redeployLoading}
                    />{" "}
                    Agente proactivo (recordatorios / seguimiento programado)
                  </Label>
                  <small className="text-muted d-block mb-2">
                    Permite programar turnos diferidos con la herramienta MCP de
                    seguimiento. Requiere incluir la herramienta en la lista MCP
                    si no usas &quot;todas las herramientas&quot;.
                  </small>
                  {editForm.proactiveEnabled && (
                    <>
                      <Label for="editProactiveMaxDelay">
                        Retraso máximo permitido (minutos)
                      </Label>
                      <Input
                        id="editProactiveMaxDelay"
                        type="number"
                        min={1}
                        max={999999}
                        value={editForm.proactiveMaxDelayMinutes}
                        onChange={(e) =>
                          handleEditFormChange(
                            "proactiveMaxDelayMinutes",
                            parseInt(e.target.value, 10) || 1
                          )
                        }
                        disabled={redeployLoading}
                      />
                      <small className="text-muted">
                        Límite superior (minutos) para tareas programadas desde
                        MCP.
                      </small>
                    </>
                  )}
                </FormGroup>
              </Col>
            </Row>

            <FormGroup>
              <Label for="agentDescription">Descripción</Label>
              <Input
                id="agentDescription"
                type="textarea"
                rows="3"
                value={editForm.description}
                onChange={(e) =>
                  handleEditFormChange("description", e.target.value)
                }
                placeholder="Descripción del agente"
                disabled={redeployLoading}
              />
            </FormGroup>

            <FormGroup>
              <Label for="agentSystemInstructions">
                Instrucciones del Sistema *
              </Label>
              <Input
                id="agentSystemInstructions"
                type="textarea"
                rows="6"
                value={editForm.systemInstructions}
                onChange={(e) =>
                  handleEditFormChange("systemInstructions", e.target.value)
                }
                placeholder="Instrucciones del sistema para el agente"
                required
                disabled={redeployLoading}
              />
            </FormGroup>

            {/* Database Connections Section */}
            <hr className="my-4" />
            <h5 className="mb-3">
              <i className="fas fa-database me-2 text-primary"></i>
              Conexiones de Base de Datos
            </h5>
            <DatabaseConnectionsForm
              connections={editForm.databaseConnections}
              onChange={(connections) =>
                handleEditFormChange("databaseConnections", connections)
              }
            />

            {/* WhatsApp Accounts Section */}
            <hr className="my-4" />
            <h5 className="mb-3">
              <i className="fab fa-whatsapp me-2 text-success"></i>
              Cuentas de WhatsApp
            </h5>
            <WhatsAppAccountsForm
              accounts={editForm.whatsappAccounts}
              onChange={(accounts) =>
                handleEditFormChange("whatsappAccounts", accounts)
              }
              agentId={editingAgent?.agentId}
              token={props.token}
              onBulkTemplate={(whatsappAccount) =>
                openBulkTemplateModal(whatsappAccount, editingAgent)
              }
            />

            {/* MCP Tools Section */}
            <hr className="my-4" />
            <h5 className="mb-3">
              <i className="fas fa-tools me-2 text-warning"></i>
              Herramientas MCP
            </h5>
            <FormGroup>
              <Label>Seleccionar Herramientas MCP</Label>
              {editForm.proactiveEnabled && (
                <small className="text-muted d-block mb-2">
                  Incluye <code>schedule_proactive_follow_up_tool</code> si usas
                  una lista restringida de herramientas.
                </small>
              )}
              <div
                style={{ position: "relative" }}
                data-mcp-tools-dropdown-edit
              >
                <div
                  onClick={() => {
                    if (!redeployLoading) {
                      setMcpToolsDropdownOpenEdit(!mcpToolsDropdownOpenEdit);
                      if (!mcpToolsDropdownOpenEdit) {
                        setMcpToolsSearchEdit(""); // Clear search when opening
                      }
                    }
                  }}
                  style={{
                    border: "1px solid #ced4da",
                    borderRadius: "0.25rem",
                    padding: "0.5rem 0.75rem",
                    minHeight: "38px",
                    backgroundColor: redeployLoading ? "#e9ecef" : "#fff",
                    cursor: redeployLoading ? "not-allowed" : "pointer",
                    display: "flex",
                    alignItems: "center",
                    flexWrap: "wrap",
                    gap: "0.5rem",
                    opacity: redeployLoading ? 0.6 : 1,
                  }}
                >
                  {editForm.tools && editForm.tools.length > 0 ? (
                    editForm.tools.map((toolId) => {
                      const tool = mcpTools.find(
                        (t) => t.identifier === toolId
                      );
                      return tool ? (
                        <span
                          key={toolId}
                          className="badge"
                          style={{
                            backgroundColor: "#ff6b35",
                            color: "#fff",
                            padding: "0.35em 0.65em",
                            fontSize: "0.875em",
                            borderRadius: "0.25rem",
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "0.5rem",
                          }}
                          onClick={(e) => {
                            if (!redeployLoading) {
                              e.stopPropagation();
                              handleEditFormChange(
                                "tools",
                                editForm.tools.filter((id) => id !== toolId)
                              );
                            }
                          }}
                        >
                          {tool.name}
                          {!redeployLoading && (
                            <i
                              className="fas fa-times"
                              style={{ cursor: "pointer", fontSize: "0.75em" }}
                            ></i>
                          )}
                        </span>
                      ) : null;
                    })
                  ) : (
                    <span style={{ color: "#6c757d" }}>
                      Selecciona herramientas MCP...
                    </span>
                  )}
                  <i
                    className={`fas fa-chevron-${
                      mcpToolsDropdownOpenEdit ? "up" : "down"
                    }`}
                    style={{
                      marginLeft: "auto",
                      color: "#6c757d",
                    }}
                  ></i>
                </div>
                {mcpToolsDropdownOpenEdit && !redeployLoading && (
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      right: 0,
                      backgroundColor: "#fff",
                      border: "1px solid #ced4da",
                      borderTop: "none",
                      borderRadius: "0 0 0.25rem 0.25rem",
                      maxHeight: "200px",
                      overflowY: "auto",
                      zIndex: 1000,
                      boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                    }}
                  >
                    {/* Search Input */}
                    <div
                      style={{
                        padding: "0.5rem",
                        borderBottom: "1px solid #f0f0f0",
                      }}
                    >
                      <Input
                        type="text"
                        placeholder="Buscar herramientas..."
                        value={mcpToolsSearchEdit}
                        onChange={(e) => {
                          e.stopPropagation();
                          setMcpToolsSearchEdit(e.target.value);
                        }}
                        onClick={(e) => e.stopPropagation()}
                        style={{
                          fontSize: "0.875rem",
                          padding: "0.375rem 0.75rem",
                        }}
                      />
                    </div>
                    {mcpTools.length > 0 ? (
                      (() => {
                        const filteredTools = mcpToolsSearchEdit.trim()
                          ? mcpTools.filter((tool) => {
                              const searchLower =
                                mcpToolsSearchEdit.toLowerCase();
                              return (
                                tool.name.toLowerCase().includes(searchLower) ||
                                tool.identifier
                                  .toLowerCase()
                                  .includes(searchLower) ||
                                (tool.description &&
                                  tool.description
                                    .toLowerCase()
                                    .includes(searchLower))
                              );
                            })
                          : mcpTools;

                        return filteredTools.length > 0 ? (
                          filteredTools.map((tool) => {
                            const isSelected =
                              editForm.tools &&
                              editForm.tools.includes(tool.identifier);
                            return (
                              <div
                                key={tool._id}
                                onClick={() => {
                                  const currentTools = editForm.tools || [];
                                  if (isSelected) {
                                    handleEditFormChange(
                                      "tools",
                                      currentTools.filter(
                                        (id) => id !== tool.identifier
                                      )
                                    );
                                  } else {
                                    handleEditFormChange("tools", [
                                      ...currentTools,
                                      tool.identifier,
                                    ]);
                                  }
                                }}
                                style={{
                                  padding: "0.75rem 1rem",
                                  cursor: "pointer",
                                  backgroundColor: isSelected
                                    ? "#f8f9fa"
                                    : "#fff",
                                  borderBottom: "1px solid #f0f0f0",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "0.75rem",
                                  transition: "background-color 0.2s",
                                }}
                                onMouseEnter={(e) => {
                                  if (!isSelected)
                                    e.currentTarget.style.backgroundColor =
                                      "#f8f9fa";
                                }}
                                onMouseLeave={(e) => {
                                  if (!isSelected)
                                    e.currentTarget.style.backgroundColor =
                                      "#fff";
                                }}
                              >
                                <input
                                  type="checkbox"
                                  checked={isSelected}
                                  onChange={() => {}}
                                  style={{
                                    cursor: "pointer",
                                    width: "18px",
                                    height: "18px",
                                  }}
                                />
                                <div style={{ flex: 1 }}>
                                  <div
                                    style={{
                                      fontWeight: "500",
                                      color: "#2c3e50",
                                    }}
                                  >
                                    {tool.name}
                                  </div>
                                  <div
                                    style={{
                                      fontSize: "0.875em",
                                      color: "#6c757d",
                                    }}
                                  >
                                    <code>{tool.identifier}</code>
                                  </div>
                                  {tool.description && (
                                    <div
                                      style={{
                                        fontSize: "0.75em",
                                        color: "#868e96",
                                        marginTop: "0.25rem",
                                      }}
                                    >
                                      {tool.description.length > 60
                                        ? `${tool.description.substring(
                                            0,
                                            60
                                          )}...`
                                        : tool.description}
                                    </div>
                                  )}
                                </div>
                              </div>
                            );
                          })
                        ) : (
                          <div
                            style={{
                              padding: "1rem",
                              textAlign: "center",
                              color: "#6c757d",
                            }}
                          >
                            No se encontraron herramientas que coincidan con "
                            {mcpToolsSearchEdit}"
                          </div>
                        );
                      })()
                    ) : (
                      <div
                        style={{
                          padding: "1rem",
                          textAlign: "center",
                          color: "#6c757d",
                        }}
                      >
                        No hay herramientas disponibles
                      </div>
                    )}
                  </div>
                )}
              </div>
              <small className="text-muted d-block mt-2">
                Si no seleccionas ninguna, el agente tendrá acceso a todas las
                herramientas disponibles.
              </small>
            </FormGroup>

            <FormGroup>
              <Label for="agentActive">Estado del Agente</Label>
              <div className="d-flex align-items-center">
                <div
                  className={`toggle-switch ${
                    editForm.isActive ? "active" : ""
                  }`}
                  onClick={() =>
                    handleEditFormChange("isActive", !editForm.isActive)
                  }
                  style={{
                    width: "60px",
                    height: "30px",
                    backgroundColor: editForm.isActive ? "#28a745" : "#6c757d",
                    borderRadius: "15px",
                    position: "relative",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                    border: "2px solid transparent",
                  }}
                >
                  <div
                    className="toggle-slider"
                    style={{
                      width: "24px",
                      height: "24px",
                      backgroundColor: "white",
                      borderRadius: "50%",
                      position: "absolute",
                      top: "1px",
                      left: editForm.isActive ? "33px" : "1px",
                      transition: "all 0.3s ease",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                    }}
                  />
                </div>
                <span
                  className="ms-3 fw-bold"
                  style={{ color: editForm.isActive ? "#28a745" : "#6c757d" }}
                >
                  {editForm.isActive ? "Activo" : "Inactivo"}
                </span>
              </div>
            </FormGroup>

            <FormGroup check className="mb-3">
              <Label check>
                <Input
                  type="checkbox"
                  checked={scheduleDeactivationEdit}
                  onChange={(e) => setScheduleDeactivationEdit(e.target.checked)}
                  disabled={redeployLoading}
                />{" "}
                Programar desactivación automática (expiración)
              </Label>
            </FormGroup>

            {scheduleDeactivationEdit && (
              <FormGroup>
                <Label for="editAgentActiveTo">Activo hasta</Label>
                <Input
                  id="editAgentActiveTo"
                  type="date"
                  value={editForm.activeTo}
                  onChange={(e) =>
                    handleEditFormChange("activeTo", e.target.value)
                  }
                  disabled={redeployLoading}
                />
                <small className="text-muted">
                  A partir de esta fecha el agente se tratará como inactivo
                  automáticamente, sin necesidad de desactivarlo manualmente.
                </small>
              </FormGroup>
            )}

            <FormGroup>
              <Label for="editAgentFallbackMessage">
                Mensaje cuando el agente está inactivo
              </Label>
              <Input
                id="editAgentFallbackMessage"
                type="textarea"
                rows="2"
                value={editForm.fallbackMessage}
                onChange={(e) =>
                  handleEditFormChange("fallbackMessage", e.target.value)
                }
                placeholder="Ej: Para hablar con nosotros escríbenos al 310 7641654"
                disabled={redeployLoading}
              />
              <small className="text-muted">
                Se envía al usuario en lugar de ejecutar el flujo del agente
                cuando el agente está desactivado (manualmente o por la fecha
                de expiración de arriba). Si se deja vacío, no se envía
                ninguna respuesta.
              </small>
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button
            type="button"
            color="info"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              openTestModal(editForm, "edit");
            }}
            disabled={
              editLoading ||
              redeployLoading ||
              !editForm.name.trim() ||
              !editForm.systemInstructions.trim() ||
              !editForm.model.trim()
            }
            style={{ marginRight: "auto" }}
          >
            <i className="fas fa-vial me-2"></i>
            Probar Agente
          </Button>
          <Button
            color="secondary"
            onClick={closeEditModal}
            disabled={redeployLoading || editLoading}
          >
            Cancelar
          </Button>
          {hasDeploymentChanges() && (
            <Button
              color="warning"
              onClick={handleSaveAndRedeploy}
              disabled={
                redeployLoading ||
                editLoading ||
                !editForm.name.trim() ||
                !editForm.systemInstructions.trim() ||
                !editForm.model.trim()
              }
            >
              {redeployLoading ? (
                <>
                  <Spinner size="sm" className="me-2" />
                  Redesplegando...
                </>
              ) : (
                <>
                  <i className="fas fa-redo me-2"></i>
                  Guardar y Redesplegar
                </>
              )}
            </Button>
          )}
          <Button
            color="primary"
            onClick={handleEditSubmit}
            disabled={
              editLoading ||
              redeployLoading ||
              !editForm.name.trim() ||
              hasDeploymentChanges()
            }
          >
            {editLoading ? (
              <>
                <Spinner size="sm" className="me-2" />
                Guardando...
              </>
            ) : (
              "Guardar Cambios"
            )}
          </Button>
        </ModalFooter>
      </Modal>

      {/* View Agent Modal */}
      <Modal
        isOpen={viewModal}
        toggle={isCompiling ? undefined : closeViewModal}
        size="xl"
        backdrop={isCompiling ? "static" : true}
        keyboard={!isCompiling}
      >
        <ModalHeader
          toggle={isCompiling ? undefined : closeViewModal}
          style={{ backgroundColor: "#ff6b35" }}
          className="text-white"
        >
          <i className="fas fa-eye me-2"></i>
          Detalles del Agente: {viewingAgent?.name}
          {isCompiling && (
            <span className="ms-2">
              <i className="fas fa-spinner fa-spin me-2"></i>
              Compilando...
            </span>
          )}
        </ModalHeader>
        <ModalBody className="p-4">
          {viewingAgent && (
            <div className="agent-details">
              {/* Header Section */}
              <div className="text-center mb-4">
                <div className="agent-avatar mb-3">
                  <i
                    className="fas fa-robot fa-4x"
                    style={{ color: "#ff6b35" }}
                  ></i>
                </div>
                <h3 className="mb-2" style={{ color: "#ff6b35" }}>
                  {viewingAgent.name || "Sin nombre"}
                </h3>
                <span
                  className={`badge fs-6 ${
                    isCurrentlyActiveAgent(viewingAgent)
                      ? "bg-success"
                      : "bg-secondary"
                  }`}
                >
                  {isCurrentlyActiveAgent(viewingAgent) ? "Activo" : "Inactivo"}
                </span>
              </div>

              <Row>
                {/* Basic Information */}
                <Col lg={6} className="mb-4">
                  <Card className="h-100 border-0 shadow-sm">
                    <CardBody>
                      <h5
                        className="card-title mb-3"
                        style={{ color: "#ff6b35" }}
                      >
                        <i
                          className="fas fa-info-circle me-2"
                          style={{ color: "#ff6b35" }}
                        ></i>
                        Información Básica
                      </h5>

                      <div className="info-item mb-3">
                        <label className="fw-bold text-muted">Nombre:</label>
                        <p className="mb-1">
                          {viewingAgent.name || "No especificado"}
                        </p>
                      </div>

                      <div className="info-item mb-3">
                        <label className="fw-bold text-muted">
                          ID del Agente:
                        </label>
                        <p className="mb-1 font-monospace">
                          {viewingAgent.agentId || "No especificado"}
                        </p>
                      </div>

                      <div className="info-item mb-3">
                        <label className="fw-bold text-muted">Tipo:</label>
                        <span className="badge bg-light text-dark border border-secondary fs-6">
                          {getAgentTypeLabel(viewingAgent.type)}
                        </span>
                      </div>

                      <div className="info-item mb-3">
                        <label className="fw-bold text-muted">Estado:</label>
                        <span
                          className={`badge bg-light text-dark border fs-6 ${
                            isCurrentlyActiveAgent(viewingAgent)
                              ? "border-success"
                              : "border-secondary"
                          }`}
                          style={{ color: "#212529" }}
                        >
                          {isCurrentlyActiveAgent(viewingAgent)
                            ? "Activo"
                            : "Inactivo"}
                        </span>
                      </div>

                      <div className="info-item mb-3">
                        <label className="fw-bold text-muted">
                          Estado de Despliegue:
                        </label>
                        <div className="mt-1">
                          {getDeploymentStatusBadge(
                            viewingAgent.deploymentStatus
                          ) || (
                            <span className="text-muted">No desplegado</span>
                          )}
                        </div>
                      </div>

                      {viewingAgent.activeTo && (
                        <div className="info-item mb-3">
                          <label className="fw-bold text-muted">
                            Activo hasta (expiración):
                          </label>
                          <p className="mb-1">
                            {formatDate(viewingAgent.activeTo)}
                          </p>
                        </div>
                      )}

                      {viewingAgent.fallbackMessage && (
                        <div className="info-item mb-3">
                          <label className="fw-bold text-muted">
                            Mensaje cuando está inactivo:
                          </label>
                          <p className="mb-1">
                            {viewingAgent.fallbackMessage}
                          </p>
                        </div>
                      )}
                    </CardBody>
                  </Card>
                </Col>

                {/* Technical Configuration */}
                <Col lg={6} className="mb-4">
                  <Card className="h-100 border-0 shadow-sm">
                    <CardBody>
                      <h5
                        className="card-title mb-3"
                        style={{ color: "#ff6b35" }}
                      >
                        <i
                          className="fas fa-cogs me-2"
                          style={{ color: "#ff6b35" }}
                        ></i>
                        Configuración Técnica
                      </h5>

                      <div className="info-item mb-3">
                        <label className="fw-bold text-muted">
                          URL del Manager:
                        </label>
                        <p className="mb-1">
                          {viewingAgent.managerBaseUrl ? (
                            <a
                              href={viewingAgent.managerBaseUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ color: "#ff6b35" }}
                            >
                              {viewingAgent.managerBaseUrl}
                            </a>
                          ) : (
                            "No especificado"
                          )}
                        </p>
                      </div>

                      <div className="info-item mb-3">
                        <label className="fw-bold text-muted">
                          Bucket GCS:
                        </label>
                        <p className="mb-1 font-monospace">
                          {viewingAgent.agentGCSBucket || "No especificado"}
                        </p>
                      </div>

                      <div className="info-item mb-3">
                        <label className="fw-bold text-muted">
                          Tiempo de Caché:
                        </label>
                        <p className="mb-1">
                          {viewingAgent.cacheTime !== undefined
                            ? `${viewingAgent.cacheTime} segundos`
                            : "10 segundos (por defecto)"}
                        </p>
                        <small className="text-muted">
                          {viewingAgent.cacheTime === 0
                            ? "Los mensajes se procesan inmediatamente"
                            : "Los mensajes se agrupan y procesan después de este tiempo de inactividad"}
                        </small>
                      </div>

                      <div className="info-item mb-3">
                        <label className="fw-bold text-muted">
                          Agente proactivo:
                        </label>
                        <p className="mb-1">
                          {viewingAgent.proactiveEnabled
                            ? "Sí"
                            : "No"}
                          {viewingAgent.proactiveEnabled &&
                            viewingAgent.proactiveMaxDelayMinutes != null && (
                              <span className="text-muted ms-2">
                                (máx.{" "}
                                {viewingAgent.proactiveMaxDelayMinutes} min)
                              </span>
                            )}
                        </p>
                        <small className="text-muted">
                          Permite recordatorios y seguimientos programados vía
                          MCP cuando está habilitado.
                        </small>
                      </div>

                      {/* Compilar Button - Only visible when both GCS bucket and manager URL exist */}
                      {viewingAgent.agentGCSBucket &&
                        viewingAgent.managerBaseUrl && (
                          <div className="mt-3">
                            <Button
                              color="primary"
                              size="sm"
                              onClick={() => handleCompile(viewingAgent)}
                              disabled={isCompiling}
                              style={{
                                backgroundColor: isCompiling
                                  ? "#6c757d"
                                  : "#ff6b35",
                                borderColor: isCompiling
                                  ? "#6c757d"
                                  : "#ff6b35",
                                opacity: isCompiling ? 0.6 : 1,
                              }}
                            >
                              {isCompiling ? (
                                <>
                                  <i className="fas fa-spinner fa-spin me-2"></i>
                                  Compilando...
                                </>
                              ) : (
                                <>
                                  <i className="fas fa-cogs me-2"></i>
                                  Compilar
                                </>
                              )}
                            </Button>
                          </div>
                        )}
                    </CardBody>
                  </Card>
                </Col>
              </Row>

              {/* Description */}
              <Row>
                <Col xs={12} className="mb-4">
                  <Card className="border-0 shadow-sm">
                    <CardBody>
                      <h5
                        className="card-title mb-3"
                        style={{ color: "#ff6b35" }}
                      >
                        <i
                          className="fas fa-align-left me-2"
                          style={{ color: "#ff6b35" }}
                        ></i>
                        Descripción
                      </h5>
                      <div className="info-item">
                        <p className="mb-0">
                          {viewingAgent.description ||
                            "No hay descripción disponible para este agente."}
                        </p>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>

              {/* System Instructions */}
              <Row>
                <Col xs={12} className="mb-4">
                  <Card className="border-0 shadow-sm">
                    <CardBody>
                      <h5
                        className="card-title mb-3"
                        style={{ color: "#ff6b35" }}
                      >
                        <i
                          className="fas fa-brain me-2"
                          style={{ color: "#ff6b35" }}
                        ></i>
                        Instrucciones del Sistema
                      </h5>
                      <div className="info-item">
                        <div
                          className="mb-0"
                          style={{
                            whiteSpace: "pre-wrap",
                            fontFamily: "inherit",
                            lineHeight: "1.6",
                          }}
                        >
                          {viewingAgent.systemInstructions ||
                            "No hay instrucciones del sistema configuradas."}
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>

              {/* Metadata */}
              <Row>
                <Col xs={12}>
                  <Card className="border-0 shadow-sm">
                    <CardBody>
                      <h5
                        className="card-title mb-3"
                        style={{ color: "#ff6b35" }}
                      >
                        <i
                          className="fas fa-history me-2"
                          style={{ color: "#ff6b35" }}
                        ></i>
                        Metadatos
                      </h5>
                      <Row>
                        <Col md={6}>
                          <div className="info-item mb-3">
                            <label className="fw-bold text-muted">
                              Fecha de Creación:
                            </label>
                            <p className="mb-1">
                              {formatDate(viewingAgent.dateCreated)}
                            </p>
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="info-item mb-3">
                            <label className="fw-bold text-muted">
                              Última Actualización:
                            </label>
                            <p className="mb-1">
                              {formatDate(viewingAgent.dateUpdated)}
                            </p>
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </div>
          )}
        </ModalBody>
        <ModalFooter className="bg-light">
          <Button
            color="secondary"
            onClick={closeViewModal}
            disabled={isCompiling}
          >
            <i className="fas fa-times me-2"></i>
            {isCompiling ? "Compilando..." : "Cerrar"}
          </Button>
          <Button
            color="primary"
            onClick={() => {
              closeViewModal();
              openEditModal(viewingAgent);
            }}
            disabled={isCompiling}
          >
            <i className="fas fa-edit me-2"></i>
            {isCompiling ? "Compilando..." : "Editar Agente"}
          </Button>
        </ModalFooter>
      </Modal>

      {/* Build Success Modal */}
      <Modal
        isOpen={buildSuccessModal}
        toggle={() => setBuildSuccessModal(false)}
        size="md"
      >
        <ModalHeader
          toggle={() => setBuildSuccessModal(false)}
          style={{ backgroundColor: "#28a745" }}
          className="text-white"
        >
          <i className="fas fa-check-circle me-2"></i>
          Compilación Exitosa
        </ModalHeader>
        <ModalBody className="p-4">
          <div className="text-center">
            <i className="fas fa-robot fa-3x text-success mb-3"></i>
            <h4 className="text-success mb-3">
              ¡Agente Compilado Exitosamente!
            </h4>
            <p className="mb-3">
              El agente ha sido compilado y está listo para usar.
            </p>

            <div className="bg-light p-3 rounded mb-4">
              <label className="fw-bold text-muted mb-2 d-block">
                Build ID:
              </label>
              <code className="fs-6 text-primary">{buildId}</code>
            </div>

            <p className="text-muted small mb-4">
              Puedes copiar el Build ID al portapapeles o guardarlo directamente
              en el agente.
            </p>
          </div>
        </ModalBody>
        <ModalFooter className="bg-light">
          <Button color="secondary" onClick={() => setBuildSuccessModal(false)}>
            <i className="fas fa-times me-2"></i>
            Cerrar
          </Button>
          <Button color="info" onClick={copyBuildId}>
            <i className="fas fa-copy me-2"></i>
            Copiar Build ID
          </Button>
          <Button color="success" onClick={saveBuildIdToAgent}>
            <i className="fas fa-save me-2"></i>
            Guardar en Agente
          </Button>
        </ModalFooter>
      </Modal>

      {/* Bulk Template Modal */}
      <Modal
        isOpen={bulkTemplateModal}
        toggle={closeBulkTemplateModal}
        size="lg"
        backdrop={showDetailedResults ? "static" : true}
      >
        <ModalHeader toggle={closeBulkTemplateModal}>
          <i className="fas fa-paper-plane me-2"></i>
          Envío Masivo de Templates
        </ModalHeader>
        <ModalBody>
          {bulkTemplateLoading && (
            <div className="mb-3">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <span className="text-muted">
                  Procesando lote {bulkTemplateProgress.currentBatch} de {bulkTemplateProgress.totalBatches}
                </span>
                <span className="text-muted">
                  {bulkTemplateProgress.currentSent + bulkTemplateProgress.currentFailed} / {bulkTemplateProgress.totalRecipients} destinatarios
                </span>
              </div>
              <Progress 
                value={bulkTemplateProgress.totalBatches > 0 ? Math.min((bulkTemplateProgress.currentBatch / bulkTemplateProgress.totalBatches) * 100, 100) : 0} 
                color="primary"
                className="mb-2"
                animated
                striped
              >
                {bulkTemplateProgress.totalBatches > 0 ? Math.round(Math.min((bulkTemplateProgress.currentBatch / bulkTemplateProgress.totalBatches) * 100, 100)) : 0}%
              </Progress>
              <div className="d-flex justify-content-between small text-muted">
                <span>
                  <i className="fas fa-check-circle text-success me-1"></i>
                  Exitosos: {bulkTemplateProgress.currentSent}
                </span>
                <span>
                  <i className="fas fa-times-circle text-danger me-1"></i>
                  Fallidos: {bulkTemplateProgress.currentFailed}
                </span>
              </div>
            </div>
          )}

          {bulkTemplateError && (
            <Alert color="danger" className="mb-3">
              {bulkTemplateError}
            </Alert>
          )}

          {bulkTemplateSuccess && (
            <Alert color="success" className="mb-3">
              {bulkTemplateSuccess}
              {bulkTemplateResults && (
                <div className="mt-2">
                  <Button
                    color="link"
                    size="sm"
                    className="p-0 text-decoration-none"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setShowDetailedResults(!showDetailedResults);
                    }}
                    type="button"
                  >
                    {showDetailedResults ? (
                      <><i className="fas fa-chevron-up me-1"></i> Ocultar detalles</>
                    ) : (
                      <><i className="fas fa-chevron-down me-1"></i> Ver detalles</>
                    )}
                  </Button>
                </div>
              )}
            </Alert>
          )}

          {bulkTemplateResults && showDetailedResults && (
            <div 
              className="mb-3"
              onClick={(e) => e.stopPropagation()}
            >
              {bulkTemplateResults.successfulPhoneNumbers.length > 0 && (
                <div className="mb-3">
                  <h6 className="text-success">
                    <i className="fas fa-check-circle me-2"></i>
                    Exitosos ({bulkTemplateResults.successfulPhoneNumbers.length}):
                  </h6>
                  <div 
                    className="border rounded p-2 bg-light" 
                    style={{ maxHeight: '200px', overflowY: 'auto' }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <ul className="mb-0" style={{ listStyle: 'none', paddingLeft: 0 }}>
                      {bulkTemplateResults.successfulPhoneNumbers.map((item, index) => (
                        <li key={index} className="mb-1">
                          <span className="badge bg-success me-2">
                            <i className="fas fa-check"></i>
                          </span>
                          {item.phoneNumber}
                          {item.timestamp && (
                            <small className="text-muted ms-2">
                              ({new Date(item.timestamp).toLocaleString()})
                            </small>
                          )}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              )}

              {bulkTemplateResults.failedPhoneNumbers.length > 0 && (
                <div className="mb-3">
                  <h6 className="text-danger">
                    <i className="fas fa-times-circle me-2"></i>
                    Fallidos ({bulkTemplateResults.failedPhoneNumbers.length}):
                  </h6>
                  <div 
                    className="border rounded p-2 bg-light" 
                    style={{ maxHeight: '200px', overflowY: 'auto' }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <ul className="mb-0" style={{ listStyle: 'none', paddingLeft: 0 }}>
                      {bulkTemplateResults.failedPhoneNumbers.map((item, index) => (
                        <li key={index} className="mb-2">
                          <div>
                            <span className="badge bg-danger me-2">
                              <i className="fas fa-times"></i>
                            </span>
                            <strong>{item.phoneNumber}</strong>
                            {item.timestamp && (
                              <small className="text-muted ms-2">
                                ({new Date(item.timestamp).toLocaleString()})
                              </small>
                            )}
                          </div>
                          {item.error && (
                            <div className="ms-4 text-danger small">
                              <small>{item.error}</small>
                            </div>
                          )}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              )}

              {bulkTemplateResults.errors && bulkTemplateResults.errors.length > 0 && (
                <div className="mb-3">
                  <h6 className="text-warning">
                    <i className="fas fa-exclamation-triangle me-2"></i>
                    Errores adicionales:
                  </h6>
                  <div 
                    className="border rounded p-2 bg-light" 
                    style={{ maxHeight: '150px', overflowY: 'auto' }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <ul className="mb-0 small">
                      {bulkTemplateResults.errors.map((error, index) => (
                        <li key={index} className="text-warning">{error}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              )}
            </div>
          )}

          <Form>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="templateName">Nombre del Template *</Label>
                  <Input
                    id="templateName"
                    type="text"
                    value={bulkTemplateForm.templateName}
                    onChange={(e) =>
                      handleBulkTemplateFormChange(
                        "templateName",
                        e.target.value
                      )
                    }
                    placeholder="Nombre del template de WhatsApp"
                    required
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="templateLanguage">Idioma</Label>
                  <Input
                    id="templateLanguage"
                    type="select"
                    value={bulkTemplateForm.language}
                    onChange={(e) =>
                      handleBulkTemplateFormChange("language", e.target.value)
                    }
                  >
                    <option value="es_MX">Español (México)</option>
                    <option value="es_ES">Español (España)</option>
                    <option value="es_CO">Español (Colombia)</option>
                    <option value="en_US">English (US)</option>
                  </Input>
                </FormGroup>
              </Col>
            </Row>

            <FormGroup>
              <Label for="excelFile">Archivo Excel *</Label>
              <div className="d-flex align-items-center gap-2 mb-2">
                <Input
                  id="excelFile"
                  type="file"
                  accept=".xlsx,.xls"
                  onChange={(e) =>
                    handleBulkTemplateFormChange("excelFile", e.target.files[0])
                  }
                  required
                />
                <Button
                  color="info"
                  size="sm"
                  onClick={downloadTemplate}
                  title="Descargar plantilla de ejemplo"
                >
                  <i className="fas fa-download me-1"></i>
                  Descargar Plantilla
                </Button>
              </div>
              <small className="text-muted">
                <strong>Formato requerido:</strong>
                <br />
                • Fila 1: Nombres de columnas (ej: Telefono, Nombre, Email,
                etc.)
                <br />
                • Fila 2: Tipo de dato (PARAMETER para parámetros del template,
                CONTEXT para información del agente)
                <br />
                • Fila 3+: Datos de los destinatarios
                <br />
                <strong>Nota:</strong> La columna de teléfono debe estar marcada
                como PARAMETER
              </small>
            </FormGroup>

            {selectedWhatsAppAccount && (
              <Alert color="info" className="mt-3">
                <strong>Cuenta WhatsApp seleccionada:</strong>{" "}
                {selectedWhatsAppAccount.accountName}
                <br />
                <strong>Phone ID:</strong> {selectedWhatsAppAccount.phoneId}
              </Alert>
            )}
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={closeBulkTemplateModal}>
            Cancelar
          </Button>
          <Button
            color="primary"
            onClick={handleBulkTemplateSubmit}
            disabled={
              bulkTemplateLoading ||
              !bulkTemplateForm.templateName.trim() ||
              !bulkTemplateForm.excelFile
            }
          >
            {bulkTemplateLoading ? (
              <>
                <Spinner size="sm" className="me-2" />
                Enviando...
              </>
            ) : (
              <>
                <i className="fas fa-paper-plane me-2"></i>
                Enviar Templates
              </>
            )}
          </Button>
        </ModalFooter>
      </Modal>

      <AgentTestModal
        isOpen={testModal}
        onClose={closeTestModal}
        testInitializing={testInitializing}
        testError={testError}
        testMessages={testMessages}
        testLoading={testLoading}
        testSessionId={testSessionId}
        onSend={handleTestSend}
      />

      {/* MCP Tool Modal */}
      <Modal
        isOpen={mcpToolModal}
        toggle={mcpToolFormLoading ? undefined : closeMcpToolModal}
        backdrop={mcpToolFormLoading ? "static" : true}
        keyboard={!mcpToolFormLoading}
      >
        <ModalHeader
          toggle={mcpToolFormLoading ? undefined : closeMcpToolModal}
        >
          <i className="fas fa-tools me-2"></i>
          {editingMcpTool ? "Editar Herramienta MCP" : "Nueva Herramienta MCP"}
        </ModalHeader>
        <ModalBody>
          {mcpToolFormError && <Alert color="danger">{mcpToolFormError}</Alert>}
          <Form>
            <FormGroup>
              <Label for="mcpToolName">Nombre *</Label>
              <Input
                id="mcpToolName"
                type="text"
                value={mcpToolForm.name}
                onChange={(e) =>
                  handleMcpToolFormChange("name", e.target.value)
                }
                placeholder="Nombre amigable para visualización"
                disabled={mcpToolFormLoading}
              />
            </FormGroup>
            <FormGroup>
              <Label for="mcpToolIdentifier">Identificador *</Label>
              <Input
                id="mcpToolIdentifier"
                type="text"
                value={mcpToolForm.identifier}
                onChange={(e) =>
                  handleMcpToolFormChange("identifier", e.target.value)
                }
                placeholder="Identificador único (ej: kyt_lookup)"
                disabled={mcpToolFormLoading || editingMcpTool !== null}
              />
              <small className="text-muted">
                El identificador debe ser único y no puede cambiarse después de
                crear la herramienta.
              </small>
            </FormGroup>
            <FormGroup>
              <Label for="mcpToolDescription">Descripción</Label>
              <Input
                id="mcpToolDescription"
                type="textarea"
                rows="3"
                value={mcpToolForm.description}
                onChange={(e) =>
                  handleMcpToolFormChange("description", e.target.value)
                }
                placeholder="Descripción de qué hace esta herramienta (opcional)"
                disabled={mcpToolFormLoading}
              />
              <small className="text-muted">
                Describe brevemente qué hace esta herramienta MCP para ayudar a
                los usuarios a entender su propósito.
              </small>
            </FormGroup>
            <FormGroup>
              <Label for="mcpToolType">Tipo</Label>
              <Input
                id="mcpToolType"
                type="select"
                value={mcpToolForm.type || "builtin"}
                onChange={(e) =>
                  handleMcpToolFormChange("type", e.target.value)
                }
                disabled={mcpToolFormLoading}
              >
                <option value="builtin">Integrada (código en el servidor MCP)</option>
                <option value="http">HTTP (llamada a URL externa)</option>
              </Input>
              <small className="text-muted">
                Las herramientas HTTP se ejecutan llamando a una URL; no requieren desplegar código.
              </small>
            </FormGroup>
            {mcpToolForm.type === "http" && (
              <>
                <FormGroup>
                  <Label for="mcpToolHttpUrl">URL *</Label>
                  <Input
                    id="mcpToolHttpUrl"
                    type="text"
                    value={mcpToolForm.httpConfig?.url || ""}
                    onChange={(e) =>
                      handleMcpToolHttpConfigChange("url", e.target.value)
                    }
                    placeholder="https://api.example.com/ability/{id_or_name}/"
                    disabled={mcpToolFormLoading}
                  />
                  <small className="text-muted">
                    Usa &#123;nombre_parametro&#125; en la URL para parámetros de ruta (ej: /ability/&#123;id_or_name&#125;/). El agente enviará ese parámetro al invocar la herramienta.
                  </small>
                </FormGroup>
                <FormGroup>
                  <Label for="mcpToolHttpMethod">Método HTTP</Label>
                  <Input
                    id="mcpToolHttpMethod"
                    type="select"
                    value={(mcpToolForm.httpConfig?.method || "GET").toUpperCase()}
                    onChange={(e) =>
                      handleMcpToolHttpConfigChange("method", e.target.value)
                    }
                    disabled={mcpToolFormLoading}
                  >
                    <option value="GET">GET</option>
                    <option value="POST">POST</option>
                    <option value="PUT">PUT</option>
                    <option value="PATCH">PATCH</option>
                    <option value="DELETE">DELETE</option>
                  </Input>
                  <small className="text-muted">
                    GET: los parámetros de la URL se forman con &quot;Parámetros por defecto&quot; (si existe) y los que el agente envía (estos prevalecen). POST/PUT/PATCH: igual con &quot;Cuerpo por defecto&quot;.
                  </small>
                </FormGroup>
                {(mcpToolForm.httpConfig?.method || "GET").toUpperCase() === "GET" && (
                  <FormGroup>
                    <Label for="mcpToolHttpDefaultQueryParams">Parámetros por defecto (GET, JSON opcional)</Label>
                    <Input
                      id="mcpToolHttpDefaultQueryParams"
                      type="textarea"
                      rows="2"
                      value={
                        mcpToolForm.httpConfig?.defaultQueryParams != null
                          ? (typeof mcpToolForm.httpConfig.defaultQueryParams === "string"
                            ? mcpToolForm.httpConfig.defaultQueryParams
                            : JSON.stringify(mcpToolForm.httpConfig.defaultQueryParams, null, 2))
                          : ""
                      }
                      onChange={(e) => {
                        const v = e.target.value.trim();
                        let parsed = null;
                        if (v) {
                          try {
                            parsed = JSON.parse(v);
                          } catch (_) {
                            return;
                          }
                        }
                        handleMcpToolHttpConfigChange("defaultQueryParams", parsed);
                      }}
                      placeholder='{"apiKey": "xxx", "format": "json"}'
                      disabled={mcpToolFormLoading}
                    />
                    <small className="text-muted">
                      Objeto JSON que se añade como query string. Los parámetros que el agente envíe al invocar la herramienta se fusionan (los del agente prevalecen).
                    </small>
                  </FormGroup>
                )}
                {["POST", "PUT", "PATCH"].includes((mcpToolForm.httpConfig?.method || "GET").toUpperCase()) && (
                  <FormGroup>
                    <Label for="mcpToolHttpDefaultBody">Cuerpo por defecto (JSON opcional)</Label>
                    <Input
                      id="mcpToolHttpDefaultBody"
                      type="textarea"
                      rows="3"
                      value={
                        mcpToolForm.httpConfig?.defaultBody != null
                          ? (typeof mcpToolForm.httpConfig.defaultBody === "string"
                            ? mcpToolForm.httpConfig.defaultBody
                            : JSON.stringify(mcpToolForm.httpConfig.defaultBody, null, 2))
                          : ""
                      }
                      onChange={(e) => {
                        const v = e.target.value.trim();
                        let parsed = null;
                        if (v) {
                          try {
                            parsed = JSON.parse(v);
                          } catch (_) {
                            return;
                          }
                        }
                        handleMcpToolHttpConfigChange("defaultBody", parsed);
                      }}
                      placeholder='{"key": "value"}'
                      disabled={mcpToolFormLoading}
                    />
                    <small className="text-muted">
                      Objeto JSON que se envía como base del cuerpo. Los parámetros que el agente envíe al invocar la herramienta se fusionan sobre este objeto (los del agente prevalecen).
                    </small>
                  </FormGroup>
                )}
                <FormGroup>
                  <Label for="mcpToolHttpHeaders">Cabeceras (JSON opcional)</Label>
                  <Input
                    id="mcpToolHttpHeaders"
                    type="textarea"
                    rows="2"
                    value={
                      mcpToolForm.httpConfig?.headers != null
                        ? (typeof mcpToolForm.httpConfig.headers === "string"
                          ? mcpToolForm.httpConfig.headers
                          : JSON.stringify(mcpToolForm.httpConfig.headers, null, 2))
                        : ""
                    }
                    onChange={(e) => {
                      const v = e.target.value.trim();
                      let parsed = null;
                      if (v) {
                        try {
                          parsed = JSON.parse(v);
                        } catch (_) {
                          return;
                        }
                      }
                      handleMcpToolHttpConfigChange("headers", parsed);
                    }}
                    placeholder='{"Authorization": "Bearer ..."}'
                    disabled={mcpToolFormLoading}
                  />
                </FormGroup>
              </>
            )}
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            onClick={closeMcpToolModal}
            disabled={mcpToolFormLoading}
          >
            Cancelar
          </Button>
          <Button
            color="primary"
            onClick={handleMcpToolSubmit}
            disabled={
              mcpToolFormLoading ||
              !mcpToolForm.name.trim() ||
              !mcpToolForm.identifier.trim() ||
              (mcpToolForm.type === "http" && !mcpToolForm.httpConfig?.url?.trim())
            }
            style={{
              backgroundColor: "#ff6b35",
              borderColor: "#ff6b35",
            }}
          >
            {mcpToolFormLoading ? (
              <>
                <Spinner size="sm" className="me-2" />
                Guardando...
              </>
            ) : (
              <>
                <i className="fas fa-save me-2"></i>
                Guardar
              </>
            )}
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default connect(select)(Agentes);
